
//export const baseUrl = "https://localhost:44323/api/";
//export const baseUrl = "http://test.portal.de/api/";
//export const baseUrl = "http://192.168.201.20:8081/NewPortal/api/";
import * as React from 'react';
//import fontawesome from '@fortawesome/fontawesome'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
//import { faAws } from '@fortawesome/free-brands-svg-icons'
//import { faCheckSquare } from '@fortawesome/fontawesome-free-solid';
//import { faAward, faShieldAlt } from '@fortawesome/free-solid-svg-icons';
import { LoginUserObj, MP_Type, PermissionModel, PlantObj, PlantStatus_Type, SystemUserSystemUserGroupPlantObj } from '../../components/PortalTypes/PortalObjs';




export const baseUrl = process.env.REACT_APP_DB_API;
export const baseAuthUrl = process.env.REACT_APP_DB_AUTH;
export const baseImg = process.env.REACT_APP_DB_IMG;
export const USER_TOKEN = 'user';
export const i18NEXT_TOKEN = 'i18nextLng';
export const rtipConnectionString = process.env.REACT_APP_RTIP_DB_CONNECTIONSTRING;
export const googleAPIKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;

console.log("general.actions baseUrl:  ", baseUrl);

//API 
export const API = {    
        SUCCESSED : '_api_Received', 
        FAILED : '_api_Failed'
}
//IDENTITY
export const DISPLAY = {
    BHKW: {
        KEY: 'bhkw_report',
        OPEN: true,
        CLOSE: false,
    },
    MODE: {
        KEY: 'view_mode',
        ROW: 'ROW',
        BLOCK: 'BLOCK',
    }
}
//MainContentTypes
export const MAIN_CONTENT_TYPES = {
    ERROR: 'ERROR',
    NONE: 'NONE',
    //lists
    FIRMA_LIST: 'FIRMA_LIST',
    PLANT_LIST: 'PLANT_LIST',
    PLANTPART_LIST: 'PLANTPART_LIST',
    MAINTENANCEPLAN_LIST: 'MAINTENANCEPLAN_LIST',
    DEVICE_LIST: 'DEVICE_LIST',
    DATAPOINT_LIST: 'DATAPOINT_LIST',
    USERGROUP_LIST: 'USERGROUP_LIST',
    ROLE_LIST: 'ROLE_LIST',
    RIGHT_LIST: 'RIGHT_LIST',
    USER_LIST: 'USER_LIST',
    PRE_MP_LIST: 'PRE_MP_LIST',
    //products
    PRODUCT_LIST: 'PRODUCT_LIST',
    //add
    ADD_PLANT: 'ADD_PLANT',
    ADD_FIRMA: 'ADD_FIRMA',
    ADD_PLANTPART: 'ADD_PLANTPART',
    ADD_MAINTENANCEPLAN: 'ADD_MAINTENANCEPLAN',
    ADD_DEVICE: 'ADD_DEVICE',
    ADD_DATAPOINT: 'ADD_DATAPOINT',
    ADD_SYSTEMUSER: 'ADD_SYSTEMUSER',
    ADD_PRODUCT: 'ADD_PRODUCT',
    ADD_PRE_MP:'ADD_PRE_MP',
    //view
    VIEW_MAINTENANCEPLAN: 'VIEW_MAINTENANCEPLAN',
    VIEW_FIRMA: 'VIEW_FIRMA',
    VIEW_PLANT: 'VIEW_PLANT',
    VIEW_PLANTPART: 'VIEW_PLANTPART',
    VIEW_DEVICE: 'VIEW_DEVICE',
    VIEW_DATAPOINT: 'VIEW_DATAPOINT',
    VIEW_USERGROUP: 'VIEW_USERGROUP',
    VIEW_SYSTEMUSER: 'VIEW_SYSTEMUSER',
    VIEW_PRODUCT: 'VIEW_PRODUCT',
    VIEW_PRE_MP: 'VIEW_PRE_MP',
    // EDIT
    EDIT_MAINTENANCEPLAN: 'EDIT_MAINTENANCEPLAN',
    EDIT_FIRMA: 'EDIT_FIRMA',
    EDIT_PLANT: 'EDIT_PLANT',
    EDIT_PLANTPART: 'EDIT_PLANTPART',
    EDIT_DEVICE: 'EDIT_DEVICE',
    EDIT_DATAPOINT: 'EDIT_DATAPOINT',
    EDIT_USER: 'EDIT_USER',
    EDIT_PRODUCT: 'EDIT_PRODUCT',
    EDIT_PRE_MP: 'EDIT_PRE_MP',
    //OTHER
    DETERMINE_USERGROUP_RIGHTS: 'DETERMINE_USERGROUP_RIGHTS',
    DETERMINE_USERGROUP_ROLES: 'DETERMINE_USERGROUP_ROLES',
    CLOSE_MAINTENANCE_PLAN: 'CLOSE_MAINTENANCE_PLAN',
    PLANT_REPORTING: 'PLANT_REPORTING',
    TAGESWERTE_REPORTS: 'TAGESWERTE_REPORTS',
    WP_LIST: 'WP_LIST',
    DOCUMENT_SERVER: 'DOCUMENT_SERVER',
    TRENDS: 'TRENDS',
    ADMINISTRATION: 'ADMINISTRATION',
    HOWTO: "HOWTO",
    ADDHOWTO: "ADDHOWTO",
    EDITHOWTO: "EDITHOWTO",
    VIEWHOWTO: "VIEWHOWTO",
    RTIP_ADDNEW_PLANT: 'RTIP_ADDNEW_PLANT',
    RTIP_ADDNEW_PW: 'RTIP_ADDNEW_PW',
    RTIP_ADDNEW_PTW: 'RTIP_ADDNEW_PTW',
    RTIP_ADDNEW_BS: 'RTIP_ADDNEW_BS',
    //PRODUCT_MANAGER: 'PRODUCT_MANAGER',

    PORTAL_EMAIL: 'PORTAL_EMAIL',

    REPORT_LIST: 'REPORT_LIST',
    ADD_REPORT: 'ADD_REPORT',
    EDIT_REPORT: 'EDIT_REPORT',
    VIEW_REPORT: 'VIEW_REPORT',
}

//Breadcrumb levels
export const BREADCRUMB_LEVELS = {
    //1,2,3
    FIRMA: 'FIRMA',
    FIRMA_ADD: 'FIRMA_ADD',
    FIRMA_DETAILS: 'FIRMA_DETAILS',
    //4,5,6
    PLANT: 'PLANT',
    PLANT_ADD: 'PLANT_ADD',
    PLANT_DETAILS: 'PLANT_DETAILS',
    //7,8,9
    PLANTPART: 'PLANTPART',
    PLANTPART_ADD: 'PLANTPART_ADD',
    PLANTPART_DETAILS: 'PLANTPART_DETAILS',
    //10,11,12 & 22,23,24
    DATAPOINT_PLANTPART_LIST: 'DATAPOINT_PLANTPART_LIST',
    DATAPOINT_PLANTPART_ADD: 'DATAPOINT_PLANTPART_ADD',
    DATAPOINT_PLANTPART_DETAILS: 'DATAPOINT_PLANTPART_DETAILS',

    DATAPOINT_DEVICE_LIST: 'DATAPOINT_DEVICE_LIST',
    DATAPOINT_DEVICE_ADD: 'DATAPOINT_DEVICE_ADD',
    DATAPOINT_DEVICE_DETAILS: 'DATAPOINT_DEVICE_DETAILS',

    //13,14,15 & 16,17,18 & 25,26,27
    MAINTENANCEPLAN_PLANTPART_LIST: 'MAINTENANCEPLAN_PLANTPART_LIST',
    MAINTENANCEPLAN_PLANTPART_DETAILS: 'MAINTENANCEPLAN_PLANTPART_DETAILS',
    MAINTENANCEPLAN_PLANTPART_ADD: 'MAINTENANCEPLAN_PLANTPART_ADD',

    MAINTENANCEPLAN_ALLDEVICE_LIST: 'MAINTENANCEPLAN_ALLDEVICE_LIST',
    MAINTENANCEPLAN_ALLDEVICE_DETAILS: 'MAINTENANCEPLAN_ALLDEVICE_DETAILS',
    MAINTENANCEPLAN_ALLDEVICE_ADD: 'MAINTENANCEPLAN_ALLDEVICE_ADD',

    MAINTENANCEPLAN_DEVICE_LIST: 'MAINTENANCEPLAN_DEVICE_LIST',
    MAINTENANCEPLAN_DEVICE_DETAILS: 'MAINTENANCEPLAN_DEVICE_DETAILS',
    MAINTENANCEPLAN_DEVICE_ADD: 'MAINTENANCEPLAN_DEVICE_ADD',

    MAINTENANCEPLAN_PLANTPART_CLOSE: 'MAINTENANCEPLAN_PLANTPART_CLOSE',
    MAINTENANCEPLAN_DEVICE_CLOSE: 'MAINTENANCEPLAN_DEVICE_CLOSE',

    MAINTENANCEPLAN_PLANTPART_STOP: 'MAINTENANCEPLAN_PLANTPART_STOP',
    MAINTENANCEPLAN_DEVICE_STOP: 'MAINTENANCEPLAN_DEVICE_STOP',

    //19,20,21
    DEVICE: 'DEVICE',
    DEVICE_ADD: 'DEVICE_ADD',
    DEVICE_DETAILS: 'DEVICE_DETAILS',


    FIRMA_EDIT: 'FIRMA_EDIT',
    PLANT_EDIT: 'PLANT_EDIT',
    PLANTPART_EDIT: 'PLANTPART_EDIT',
    DATAPOINT_PLANTPART_EDIT: 'DATAPOINT_PLANTPART_EDIT',
    DATAPOINT_DEVICE_EDIT: 'DATAPOINT_DEVICE_EDIT',
    MAINTENANCEPLAN_PLANTPART_EDIT: 'MAINTENANCEPLAN_PLANTPART_EDIT',
    MAINTENANCEPLAN_DEVICE_EDIT: 'MAINTENANCEPLAN_DEVICE_EDIT',
    MAINTENANCEPLAN_ALLDEVICE_EDIT: 'MAINTENANCEPLAN_ALLDEVICE_EDIT',
    DEVICE_EDIT: 'DEVICE_EDIT',

    //
    CONTROLS_USERGROUP: 'CONTROLS_USERGROUP',
    CONTROL_USERGROUP_DETAILS: 'CONTROL_USERGROUP_DETAILS',
    CONTROLS_USER: 'CONTROLS_USER',
    CONTROL_USER_DETAILS: 'CONTROL_USER_DETAILS',
    CONTROL_USER_ADD: 'CONTROL_USER_ADD',
    ROLE_LIST: 'ROLE_LIST',
    RIGHT_LIST: 'RIGHT_LIST',
    PLANT_REPORTING: 'PLANT_REPORTING',
    DAILY_VALUES_REPORTS: 'DAILY_VALUES_REPORTS',
    DOCUMENT_SERVER: 'DOCUMENT_SERVER',
    TRENDS: "TRENDS",
    ADMINISTRATION: "ADMINISTRATION",
    HOWTO: "HOWTO",
    HOWTO_ADD: "HOWTO_ADD",
    HOWTO_DETAILS: "HOWTO_DETAILS",
    RTIP_ADDNEW_PLANT:'RTIP_ADDNEW_PLANT',
    RTIP_ADDNEW_PW: 'RTIP_ADDNEW_PW',
    RTIP_ADDNEW_PTW: 'RTIP_ADDNEW_PTW',
    RTIP_ADDNEW_BS: 'RTIP_ADDNEW_BS',

    PRODUCT: 'PRODUCT',
    PRODUCT_ADD: 'PRODUCT_ADD',
    PRODUCT_DETAILS: 'PRODUCT_DETAILS',
    PRODUCT_EDIT: 'PRODUCT_EDIT',

    PREDEFINEDMAINTENANCEPLAN: 'PREDEFINEDMAINTENANCEPLAN',
    PREDEFINEDMAINTENANCEPLAN_ADD: 'PREDEFINEDMAINTENANCEPLAN_ADD',
    PREDEFINEDMAINTENANCEPLAN_DETAILS: 'PREDEFINEDMAINTENANCEPLAN_DETAILS',
    PREDEFINEDMAINTENANCEPLAN_EDIT: 'PREDEFINEDMAINTENANCEPLAN_EDIT',

    PORTALEMAIL: 'PORTALEMAIL',
    REPORT_MANAGER: 'REPORT_MANAGER',
    REPORT_ADD: 'REPORT_ADD',
    REPORT_DETAILS: 'REPORT_DETAILS',
    REPORT_EDIT:'REPORT_EDIT',
}

export const BREADCRUMBCUSTOMIZED_TYPES = {
    ADD: 'ADD',
    DETAILS: 'DETAILS',
    LIST:'LIST',
}

//Control Button Types
export const CONTROLBUTTON_TYPES = {
    ADD: 'ADD',
    FILTER: 'FILTER',
    EDIT: 'EDIT',
    DELETE: 'DELETE',
    LINKTO: 'LINKTO',
    COLSE_MP: 'COLSE_MP',
    SEARCH: 'SEARCH',
    SAVE_AS_CSV: 'SAVE_AS_CSV',
    LIST_OF: 'LIST_OF',
}

//REPORT_PDF
export const REPORT_PDF = {
    CONTROLER_NAME: 'Pdf/',
    ACTION_TYPES: {
        GENERATE:'GENERATE_REPORT_PDF',
    }
}

//MAILING
export const MAIL = {
    CONTROLER_NAME: 'Mail/',
    ACTION_TYPES: {
        SEND_EMAIL: 'SEND_EMAIL',
    }
}


//TARGETACTUALSUMMARY
export const TARGETACTUALSUMMARY = {
    TAB_NAME: 'TabTargetActualSummaries/',
    NAME: 'TargetActualSummaries',
    ACTION_TYPES: {
        FETCH_BY_DEVICE_ID: 'FETCH_BY_DEVICE_ID_TARGETACTUALSUMMARY',
        FETCH_BY_PP_ID: 'FETCH_BY_PP_ID_TARGETACTUALSUMMARY',
        CREATE: 'CREATE_TARGETACTUALSUMMARY',
        UPDATE: 'UPDATE_TARGETACTUALSUMMARY',
        DELETE: 'DELETE_TARGETACTUALSUMMARY',
        GET_VALUES_OF_TARGETACTUALSUMMAY: 'GET_VALUES_OF_TARGETACTUALSUMMAY',
        GET_IF_CAN_BE_BHKW: 'GET_IF_CAN_BE_BHKW_TARGETACTUALSUMMAY',
        GET_LIST_OF_CHILDREN: 'GET_LIST_OF_CHILDREN_TARGETACTUALSUMMAY',
    },
}

//COMPONENTTYPE
export const COMPONENTTYPE = {
    TAB_NAME: 'TabComponentTypes/',
    NAME: 'ComponentTypes',
    ACTION_TYPES: {
        FETCH_ALL: 'FETCH_ALL_COMPONENTTYPE',
    },
    TYPES_GUID: {
        BHKW: 'GUID_BHKW'
    }
}

//FIRMA
export const FIRMA = {
    TAB_NAME : 'TabFirmas/',
    NAME : 'Firmas',
    ACTION_TYPES: {
        CREATE: 'CREATE_FIRMA',
        UPDATE: 'UPDATE_FIRMA',
        DELETE: 'DELETE_FIRMA',
        FETCH_ALL: 'FETCH_ALL_FIRMA',
        FETCH_BY_GUID: 'FETCH_BY_GUID_FIRMA',
        GET_FIRMA_MP_STATISTICS: 'GET_FIRMA_MP_STATISTICS',
        FETCH_ALL_FILES: 'FETCH_ALL_FILES_FIRMA',
        FETCH_NAMES_DICTIONARY: "FETCH_NAMES_DICTIONARY",
    }
}
//PLANT
export const PLANT = {
    TAB_NAME : 'TabPlants/',
    NAME : 'Plants',
    ACTION_TYPES : {
        CREATE: 'CREATE_PLANT',
        UPDATE: 'UPDATE_PLANT',
        DELETE: 'DELETE_PLANT',
        FETCH_ALL: 'FETCH_ALL_PLANT',
        FETCH_ALL_BY_FIRMA_ID: 'FETCH_ALL_PLANTS_BY_FIRMA_ID',
        FETCH_BGANAME_AND_IDS: 'FETCH_BGANAME_AND_IDS',
        FETCH_BY_GUID: 'FETCH_BY_GUID_PLANT',
        FETCH_ALL_FILES: 'FETCH_ALL_FILES_PLANT',
        ADD_PLANT_TO_RTIP: 'ADD_PLANT_TO_RTIP',
        DELETE_PLANT_FROM_RTIP: 'DELETE_PLANT_FROM_RTIP',
        FETCH_DIFF_PROZESSWERT_PW_ALLE: 'FETCH_DIFF_PROZESSWERT_PW_ALLE',
        FETCH_DIFF_BETRIEBSSTUNDEN_BS_ALLE: 'FETCH_DIFF_BETRIEBSSTUNDEN_BS_ALLE',
        FETCH_ALL_PW_ALLE_FROM_RTIP: 'FETCH_ALL_PW_ALLE_FROM_RTIP',
        FETCH_ALL_BS_ALLE_FROM_RTIP: 'FETCH_ALL_BS_ALLE_FROM_RTIP',
        FETCH_ALL_RTIP_TAB_BW: 'FETCH_ALL_RTIP_TAB_BW',
        FETCH_ALL_RTIP_PW_HR: 'FETCH_ALL_RTIP_PW_HR',
        FETCH_ALL_RTIP_PW_NOT_HR: 'FETCH_ALL_RTIP_PW_NOT_HR',
        FETCH_NAMES_DICTIONARY: 'FETCH_NAMES_DICTIONARY',
        ADD_NEW_TAB_BW_2_RTIP: 'ADD_NEW_TAB_BW_2_RTIP',
        ADD_NEW_PW_HR_2_RTIP: 'ADD_NEW_PW_HR_2_RTIP',
        ADD_NEW_PW_NOT_HR_2_RTIP: 'ADD_NEW_PW_NOT_HR_2_RTIP',
        ADD_NEW_KEYVALUE2_AND_INI_PWREAL_2_RTIP: 'ADD_NEW_KEYVALUE2_AND_INI_PWREAL_2_RTIP',
        ADD_NEW_BW_KEYVALUE2_2_RTIP: 'ADD_NEW_BW_KEYVALUE2_2_RTIP',
        ADD_NEW_PW_TO_RTIP_PW_ALLE: "ADD_NEW_PW_TO_RTIP_PW_ALLE", 
        ADD_NEW_BS_TO_RTIP_BW_ALLE: "ADD_NEW_BS_TO_RTIP_BW_ALLE",
    },
    STATUS: {
        ACTIVE: 'ACTIVE',
        INACTIVE:'INACTIVE',
    }
}
//PLANTPART
export const PLANTPART = {
    TAB_NAME : 'TabPlantParts/',
    NAME : 'PlantParts',
    ACTION_TYPES : {
        CREATE: 'CREATE_PLANTPART',
        UPDATE: 'UPDATE_PLANTPART',
        DELETE: 'DELETE_PLANTPART',
        FETCH_ALL: 'FETCH_ALL_PLANTPART',
        FETCH_ALL_BY_PLANT_ID: 'FETCH_ALL_PLANTPART_BY_PLANT_ID',
        FETCH_BY_GUID: 'FETCH_BY_GUID_PLANTPART',
        FETCH_DETAILS_TO_DISPALY: 'FETCH_DETAILS_TO_DISPALY_PLANTPART',
        FETCH_ALL_FILES: 'FETCH_ALL_FILES_PLANTPART',
    },
    STATUS: {
        ACTIVE: 'ACTIVE',
        INACTIVE: 'INACTIVE'
    },
}

export const HOWTO = {
    TAB_NAME:"TabHowTos/",
    NAME: "HowTos",
    ACTION_TYPES: {
        CREATE: "CREATE_HOW_TO",
        UPDATE: "UPDATE_HOW_TO",
        DELETE: "DELETE_HOW_TO",
        FETCH_ALL_HOW_TOS_BY_LANG: "FETCH_ALL_HOW_TOS_BY_LANG",
        FETCH_HOW_TO_BY_GUID: "FETCH_HOW_TO_BY_GUID",
        GET_ALL_EXISTING_TAGS:"GET_ALL_EXISTING_TAGS",
    }
}

//MAINTENANCEPLAN  ===============================================================================
export const MAINTENANCEPLAN = {
    TAB_NAME : 'TabMaintenancePlans/',
    NAME : 'MaintenancePlans',
    ACTION_TYPES : {
        CREATE: 'CREATE_MAINTENANCEPLAN',
        CREATE_AUTO: 'CREATE_AUTO_MAINTENANCEPLAN',
        UPDATE: 'UPDATE_MAINTENANCEPLAN',
        DELETE_FROM_TABLE: 'DELETE_FROM_TABLE_MAINTENANCEPLAN',
        DELETE_FROM_VIEW: 'DELETE_FROM_VIEW_MAINTENANCEPLAN',
        FETCH_ALL: 'FETCH_ALL_MAINTENANCEPLAN',
        FETCH_ALL_MAINTENANCEPLAN_BY_PLANTPART_ID: 'FETCH_ALL_MAINTENANCEPLAN_BY_PLANTPART_ID',
        FETCH_ALL_MAINTENANCEPLAN_BY_DEVICE_ID: 'FETCH_ALL_MAINTENANCEPLAN_BY_DEVICE_ID',
        FETCH_ALL_MAINTENANCEPLAN_BY_PLANT_ID:'FETCH_ALL_MAINTENANCEPLAN_BY_PLANT_ID',
        FETCH_MAINTENANCEPLAN_BY_GUID:'FETCH_MAINTENANCEPLAN_BY_GUID',
    },
    STATUS: {
        ACTIVE: 'ACTIVE',
        VERYCLOSE: 'VERYCLOSE',
        PASSED: 'PASSED',
        INACTIVE_PERIODIC: 'INACTIVE_PERIODIC',
        INACTIVE_NON_PERIODIC: 'INACTIVE_NON_PERIODIC'
    },
    TYPES: {
        NONE: 'NONE',
        DEVICE: 'DEVICE',
        PLANT_PART: 'PLANT_PART',
        ALL: 'ALL',
        ALL_DEVICES: 'ALL_DEVICES'
    },
    FILTER: {
        ALL: 'All',
        ACTIVE:'Active',
        VERYCLOSE: 'Information',
        PASSED: 'Warning',
        INACTIVE_PERIODIC: 'Inactive (Periodic)',
        INACTIVE_NON_PERIODIC: 'Inactive (non-periodic)'
    },
    PERIODICITY_TYPE: {
        DAY: 'Day',
        WEEK: 'Week',
        MONTH: 'Month',
    },
    CLOSING_TYPE: {
        CLOSE: 'CLOSE',
        STOP:'STOP',
    },
    //NOTIFYINGMEDIA: {
    //    EMAIL_DEFAULT: 'EMAIL_DEFAULT',
    //    SMS: 'SMS',
    //},
    //REMINDINGMEDIA: {
    //    EMAIL_DEFAULT: 'EMAIL_DEFAULT',
    //    SMS: 'SMS',
    //},
    getPeriodicityType: (perID,t) => {
        //console.log('getPeriodicityType', perID);
        switch ('' + perID) {
            case '1': return t(TRANS.MAINTENANCEPLAN.TIMING.DAY);
            case '2': return t(TRANS.MAINTENANCEPLAN.TIMING.WEEK);
            case '3': return t(TRANS.MAINTENANCEPLAN.TIMING.MONTH);
            default: return t(TRANS.MAINTENANCEPLAN.TIMING.NOT_DETERMINED)
        }
    },
    getTiming: (timingType,t) => {
        switch (timingType) {
            case GENERAL.MAINTENANCEPLAN.TIMING.ONLY_TIME: return t(TRANS.MAINTENANCEPLAN.TIMING.TIME);
            case GENERAL.MAINTENANCEPLAN.TIMING.ONLY_OPERATINGHOURS: return t(TRANS.MAINTENANCEPLAN.TIMING.OH);
            case GENERAL.MAINTENANCEPLAN.TIMING.TIME_AND_OPERATINGHOURS: return t(TRANS.MAINTENANCEPLAN.TIMING.TIME_AND_OH);
            default: return t(TRANS.MAINTENANCEPLAN.TIMING.NOT_DETERMINED)
        }
    },
    MEDIA: {
        NONE: 0,
        EMAIL: 1,
        SMS: 2
    }
}
             
export const MAINTENANCEPLANTASK = {
    TAB_NAME: 'TabMaintenancePlanTasks/',
    NAME: 'Tasks',
    ACTION_TYPES: {
        CREATE: 'CREATE_MAINTENANCEPLANTASK',
        CREATE_LIST: 'CREATE_LIST_MAINTENANCEPLANTASK',
        DELETE_LIST: 'DELETE_LIST_MAINTENANCEPLANTASK',
        FETCH_ALL_MAINTENANCEPLANTASK_BY_MP_ID: 'FETCH_ALL_MAINTENANCEPLANTASK_BY_MP_ID',
        TOGGLE_ISDONE: 'TOGGLE_ISDONE_MAINTENANCEPLANTASK',
    }
}
//SAVEDDAILYREPORT
export const SAVEDDAILYREPORT = {
    TAB_NAME: 'TabSavedDailyReports/',
    NAME: 'SavedDailyReports',
    ACTION_TYPES: {
        CREATE: 'CREATE_SAVEDDAILYREPORT',
        DELETE: 'DELETE_SAVEDDAILYREPORT',
        UPDATE: 'UPDATE_SAVEDDAILYREPORT',
        FETCH_ALL_SAVED_REPORTS_BY_PLANTID: 'FETCH_ALL_SAVED_REPORTS_BY_PLANTID_SAVEDDAILYREPORT',
        GET_IF_AUTO_GENERATED: 'GET_IF_AUTO_GENERATED_SAVEDDAILYREPORT',
    }
}
//SAVEDTRENDREPORT
export const SAVEDTRENDREPORT = {
    TAB_NAME: 'TabSavedTrendReports/',
    NAME: 'SavedTrendReports',
    ACTION_TYPES: {
        CREATE: 'CREATE_SAVEDTRENDREPORT',
        DELETE: 'DELETE_SAVEDTRENDREPORT',
        UPDATE: 'UPDATE_SAVEDTRENDREPORT',
        FETCH_ALL_SAVED_REPORTS_BY_PLANTID: 'FETCH_ALL_SAVED_REPORTS_BY_PLANTID_SAVEDTRENDREPORT',
    }
}
//DEVICE
export const DEVICE = {
    TAB_NAME: 'TabDevices/',
    NAME: 'Devices',
    ACTION_TYPES: {
        CREATE: 'CREATE_DEVICE',
        DELETE: 'DELETE_DEVICE',
        UPDATE: 'UPDATE_DEVICE',
        FETCH_ALL: 'FETCH_ALL_DEVICE',
        FETCH_ALL_DEVICE_BY_PLANTPART_ID: 'FETCH_ALL_DEVICE_BY_PLANTPART_ID',
        FETCH_BY_GUID: 'FETCH_BY_GUID_DEVICE',
        FETCH_ALL_FILES: 'FETCH_ALL_FILES_DEVICE',
    },
    STATUS: {
        ACTIVE: 'ACTIVE',
        INACTIVE:'INACTIVE'
    }
}
//PRODUCT
export const PRODUCT = {
    TAB_NAME: 'TabProducts/',
    NAME: 'Products',
    ACTION_TYPES: {
        FETCH_ALL: 'FETCH_ALL_PRODUCT',
        FETCHALL_FOR_ADD_DEVICE: 'FETCHALL_PRODUCT_FOR_ADD_DEVICE',
        CREATE: 'CREATE_PRODUCT',
        DELETE: 'DELETE_PRODUCT',
        UPDATE: 'UPDATE_PRODUCT',
        FETCH_BY_GUID: 'FETCH_BY_GUID_PRODUCT',
    }
}
//PREDEFINEDMAINTENANCEPLAN
export const PREDEFINEDMAINTENANCEPLAN = {
    TAB_NAME: 'TabPredefinedMaintenancePlans/',
    NAME: 'PredefinedMaintenancePlans',
    ACTION_TYPES: {
        FETCH_ALL_BY_PRODUCT_GUID: 'FETCH_ALL_PREDEFINEDMAINTENANCEPLAN_BY_PRODUCT_GUID',
        CREATE: 'CREATE_PREDEFINEDMAINTENANCEPLAN',
        DELETE: 'DELETE_PREDEFINEDMAINTENANCEPLAN',
        UPDATE: 'UPDATE_PREDEFINEDMAINTENANCEPLAN',
        FETCH_BY_GUID: 'FETCH_BY_GUID_PREDEFINEDMAINTENANCEPLAN',
    },
    STATUS: {
        ACTIVE: 'ACTIVE',
        INACTIVE: 'INACTIVE',
    },
    PERIODICITY_TYPE: {
        DAY: 'Day',
        WEEK: 'Week',
        MONTH: 'Month',
    },
}
//PREDEFINEDMAINTENANCEPLANTASKS
export const PREDEFINEDMAINTENANCEPLANTASK = {
    TAB_NAME: 'TabPredefinedMaintenancePlanTasks/',
    NAME: 'PredefinedMaintenancePlanTasks',
    ACTION_TYPES: {
        DELETE_LIST: 'DELETE_LIST_PREDEFINEDMAINTENANCEPLANTASK',
        CREATE_LIST: 'CREATE_LIST_PREDEFINEDMAINTENANCEPLANTASK',
        GET_ALL_BY_PREDEFINEDMAINTENANCEPLAN_GUID: 'GET_ALL_BY_PREDEFINEDMAINTENANCEPLAN_GUID',
    }
}
//
export const USERGROUP = {
    TAB_NAME: 'TabSystemUserGroups/',
    NAME: 'SystemUserGroups',
    ACTION_TYPES: {
        FETCH_ALL: 'FETCH_ALL_USERGROUPS',
        FETCH_BY_GUID: 'FETCH_BY_GUID_USERGROUP',
        CREATE: 'CREATE_USERGROUP',
        DELETE: 'DELETE_USERGROUP',
        UPDATE:'UPDATE_USERGROUP',
    },
    IDs: {
        SUPERADMIN_USERGROUP_ID: "GUID_SUPER_ADMIN_USERGROUP",
        SYSTEMADMIN_USERGROUP_ID: "GUID_SYSTEM_ADMIN_USERGROUP",
        CONSULTANT_USERGROUP_ID: 'GUID_CONSULTANT_USERGROUP',
        PLANTADMIN_USERGROUP_ID: 'GUID_PLANT_ADMIN_USERGROUP',
        NORMAL_USER_USERGROUP_ID : 'GUID_NORMAL_USER_USERGROUP',
    }
}
// DATAPOINT
export const DATAPOINT = {
    TAB_NAME: 'TabDataPoints/',
    NAME: 'DataPoints',
    ACTION_TYPES: {
        CREATE: 'CREATE_DATAPOINT',
        UPDATE:'UPDATE_DATAPOINT',
        FETCH_ALL_DATAPOINT_BY_PLANTPART_ID: 'FETCH_ALL_DATAPOINT_BY_PLANTPART_ID',
        FETCH_ALL_DATAPOINT_BY_DEVICE_ID: 'FETCH_ALL_DATAPOINT_BY_DEVICE_ID',
        FETCH_ALL_DATAPOINT_BY_PLANT_ID: 'FETCH_ALL_DATAPOINT_BY_PLANT_ID',
        FETCH_RELATED_RTIP_DATAPOINT: 'FETCH_RELATED_RTIP_DATAPOINT',
        FETCH_ALL_DATAPOINT_BY_REPORT_GUID_A_OR_G:'FETCH_ALL_DATAPOINT_BY_REPORT_GUID_A_OR_G_DATAPOINT',
        DELETE: 'DELETE_DATAPOINT',
        FETCH_BY_GUID: 'FETCH_BY_GUID_DATAPOINT',
        TOGGLE_IS_DISPLAY: 'TOGGLE_IS_DISPLAY_DATAPOINT',
        GET_OPERATING_HOURS_FOR_DATAPOINT: 'GET_OPERATING_HOURS_FOR_DATAPOINT',
        GET_DATAPOINTS_TO_DISPLAY: 'GET_DATAPOINTS_TO_DISPLAY',
        GET_DAILYVALUES_BETWEENTWODATES: 'GET_DAILYVALUES_BETWEENTWODATES',
        GET_DAILYVALUES_BETWEENTWODATES_FOR_DPLIST: 'GET_DAILYVALUES_BETWEENTWODATES_FOR_DPLIST',
        GET_TRENDVALUES_BETWEENTWODATES_FOR_DPLIST: 'GET_TRENDVALUES_BETWEENTWODATES_FOR_DPLIST',
    },
    STATUS: {
        ACTIVE: 'ACTIVE',
        INACTIVE:'INACTIVE',
    },
    TYPE: {
        NONE: 'NONE',
        BETRIEBSSTUNDEN: 'BETRIEBSSTUNDEN',
        PROZESSWERT: 'PROZESSWERT',
        TAGESWERT: 'TAGESWERT',
    },
    USEDFUNC: {
        MAX: 'Max_Wert',
        MIN: 'Min_Wert',
        AVG: 'AVG_Wert',
        SUM_MAXMIN: 'SUM_MaxMin',
        SUM: 'SUM_Wert',
        COUNT: 'Count_Wert',
        SUM_GEWICHT: 'SUM_Gewicht_Wert',

        //ABSOLUTE: 'ABSOLUTE',
        //YESTERDAY: 'YESTERDAY',

        ANZEIT_YES: 'ANZEIT_YES',
        ANZEIT_ABS: 'ANZEIT_ABS',
        AUSZEIT_YES: 'AUSZEIT_YES',
        AUSZEIT_ABS: 'AUSZEIT_ABS',
        STORZEIT_YES: 'STORZEIT_YES',
        STORZEIT_ABS: 'STORZEIT_ABS',

    }
}
//USER.
export const SYSTEMUSER = {
    TAB_NAME: 'TabSystemUsers/',
    NAME: 'SystemUsers',
    ACTION_TYPES: {
        FETCH_ALL: 'FETCH_ALL_USERS',
        FETCH_ALL_BY_FIRMA_ID: 'FETCH_ALL_USERS_BY_FIRMA_ID',
        FETCH_BY_GUID: "FETCH_BY_GUID_SYSTEMUSER",
        CREATE: 'CREATE_SYSTEMUSER',
        DELETE: 'DELETE_SYSTEMUSER',
        UPDATE: 'UPDATE_SYSTEMUSER',
        COUNT_USERS_IN_COMPANY: 'COUNT_USERS_IN_COMPANY_SYSTEMUSER',
        COUNT_COMPANIES_IN_USER: 'COUNT_COMPANIES_IN_USER_SYSTEMUSER',
        SET_AS_SUPERADMIN: 'SET_AS_SUPERADMIN_SYSTEMUSER',
        SET_AS_NOT_SUPERADMIN: 'SET_AS_NOT_SUPERADMIN_SYSTEMUSER',
        SET_AS_SYSTEMADMIN: 'SET_AS_SYSTEMADMIN_SYSTEMUSER',
        SET_AS_NOT_SYSTEMADMIN: 'SET_AS_NOT_SYSTEMADMIN_SYSTEMUSER',
        SET_AS_CONSULTANT: 'SET_AS_CONSULTANT_SYSTEMUSER',
        SET_AS_NOT_CONSULTANT: 'SET_AS_NOT_CONSULTANT_SYSTEMUSER',
        PASS_RECOVER: 'PASS_RECOVER_SYSTEMUSER',
        FETCH_EMAILS_BY_USERGROUP_AND_FIRMA: 'FETCH_EMAILS_BY_USERGROUP_AND_FIRMA',
    },
    STATUS: {
        ACTIVE: 'ACTIVE',
        INACTIVE: 'INACTIVE',
        SUSPENDED:'SUSPENDED',
    },
    
}

//USER_MAINTENANCEPLAN
export const USER_MAINTENANCEPLAN = {
    TAB_NAME: 'TabSystemUserMaintenancePlans/',
    NAME: 'SystemUserMaintenancePlans',
    ACTION_TYPES: {
        FETCH_ALL_BY_MAINTENANCEPLAN_ID: 'FETCH_ALL_USER_MAINTENANCEPLAN_BY_MAINTENANCEPLAN_ID',
        CREATE_LIST: 'CREATE_LIST_USER_MAINTENANCEPLAN',
        DELETE_LIST: 'DELETE_LIST_USER_MAINTENANCEPLAN',
    }
}


export const REPORT = {
    TAB_NAME: 'TabReports/',
    NAME: 'Reports',
    ACTION_TYPES: {
        FETCH_BY_GUID: 'FETCH_BY_GUID_REPORT',
        FETCH_ALL: 'FETCH_ALL_REPORT',
        FETCH_ALL_BY_GUID_AND_USERID: 'FETCH_ALL_BY_GUID_AND_USERID_REPORT',
        CREATE: 'CREATE_REPORT',
        DELETE: 'DELETE_REPORT',
        UPDATE: 'EDIT_REPORT',
    },
    TYPE: {
        DAILY: 'D',
        ACCUM: 'A',
        GROUP: 'G',
        TREND: 'T',
    }
}

export const REPORT_DATAPOINT = {
    TAB_NAME: 'TabReportDataPoints/',
    NAME: 'ReportDataPoints',
    ACTION_TYPES: {
        FETCH_BY_REPORT_GUID: 'FETCH_BY_REPORT_GUID_REPORT_DATAPOINT',
        CREATE: 'CREATE_REPORT_DATAPOINT',
        DELETE: 'DELETE_REPORT_DATAPOINT',
    }
}


export const REPORT_SET = {
    TAB_NAME: 'TabReportSets/',
    NAME: 'ReportSets',
    ACTION_TYPES: {
        FETCH_BY_GUID: 'FETCH_BY_GUID_REPORT_SET',
        FETCH_ALL: 'FETCH_ALL_REPORT_SET',
        FETCH_ALL_BY_REPORT_GUID: 'FETCH_ALL_BY_REPORT_GUID_REPORT_SET',
        CREATE: 'CREATE_REPORT_SET',
        DELETE: 'DELETE_REPORT_SET',
        EDIT: 'EDIT_REPORT_SET',
    }
}

export const REPORT_SET_DATAPOINT = {
    TAB_NAME: 'TabReportSetDataPoints/',
    NAME: 'ReportSetDataPoints',
    ACTION_TYPES: {
        FETCH_BY_REPORT_SET_GUID: 'FETCH_BY_REPORT_GUID_REPORT_SET_DATAPOINT',
        CREATE: 'CREATE_REPORT_SET_DATAPOINT',
        DELETE: 'DELETE_REPORT_SET_DATAPOINT',
    }
}

//USER_USERGROUP_PLANT
export const USER_USERGROUP_PLANT = {
    TAB_NAME: 'TabSystemUserSystemUserGroupPlants/',
    NAME: 'SystemUserSystemUserGroupPlants',
    ACTION_TYPES: {
        FETCH_ALL:'FETCH_ALL_USER_USERGROUP_PLANT',
        DELETE: 'DELETE_USER_USERGROUP_PLANT',
        CREATE: 'CREATE_USER_USERGROUP_PLANT',
        FETCH_BY_GUID: 'FETCH_BY_GUID_USER_USERGROUP_PLANT',
        COUNT_COMPANIES_IN_USER: 'COUNT_COMPANIES_IN_USER_SYSTEMUSER',
    }
}

//LOGTABLE 
export const LOGTABLE = {
    TAB_NAME: 'TabLogTables',
    NAME: 'LogTables'
}

//IDENTITY 
export const IDENTITY = {
    ACTIONS : {
        LOGIN : 'IDENTITY_LOGIN',
        LOGOUT: 'IDENTITY_LOGOUT',
        AUTH_HEADER: 'AUTH_HEADER',
        REGISTER: 'IDENTITY_REGISTER',
        ADD_EVENT_LOG: 'IDENTITY_ADD_EVENT_LOG',
    },
    RESULTS : {
        SUCCESSED: '_iden_Received',
        FAILED: '_iden_Failed'
    }
}
// ROLE
export const ROLE = {
    TAB_NAME: 'TabSystemRoles/',
    NAME: 'SystemRoles',
    ACTION_TYPES: {
        CREATE: 'CREATE_ROLE',
        UPDATE: 'UPDATE_ROLE',
        DELETE: 'DELETE_ROLE',
        FETCH_ALL: 'FETCH_ALL_ROLE',
        FETCH_BY_GUID: 'FETCH_BY_GUID_ROLE',
    },
    IDs: {
        SUPERADMIN_ROLE_ID: "GUID_SUPER_ADMIN_ROLE",
        SYSTEMADMIN_ROLE_ID: 'GUID_SYSTEM_ADMIN_ROLE',
        NORMALUSER_ROLE_ID: 'GUID_NORMAL_USER_ROLE',
        PLANTADMIN_ROLE_ID: 'GUID_PLANT_ADMIN_ROLE',
        CONSULTANT_ROLE_ID: 'GUID_CONSULTANT_ROLE',
    },
    INITIAL_USER_TAG: "INITIAL_USER",
}

// RIGHT
export const RIGHT = {
    TAB_NAME: 'TabSystemRights/',
    NAME: 'SystemRights',
    ACTION_TYPES: {
        CREATE: 'CREATE_RIGHT',
        UPDATE: 'UPDATE_RIGHT',
        DELETE: 'DELETE_RIGHT',
        FETCH_ALL: 'FETCH_ALL_RIGHT',
        FETCH_BY_GUID: 'FETCH_BY_GUID_RIGHT',
    },
    
}

//PROTOCOL
export const PROTOCOL = {
    TAB_NAME: 'TabMaintenancePlanProtocols/',
    NAME: 'MaintenancePlanProtocols',
    ACTION_TYPES: {
        CREATE: 'CREATE_PROTOCOL',
        FETCH_BY_GUID: 'FETCH_BY_GUID_PROTOCOL',
    }
}

export const USERGROUP_ROLE = {
    TAB_NAME: 'TabSystemUserGroupSystemRoles/',
    NAME: 'SystemUserGroupSystemRoles',
    ACTION_TYPES: {
        DELETE: 'DELETE_USERGROUP_ROLE',
        CREATE: 'CREATE_USERGROUP_ROLE',
        CREATE_LIST: 'CREATE_LIST_USERGROUP_ROLES',
    }
}

export const USERGROUP_RIGHT = {
    TAB_NAME: 'TabSystemUserGroupSystemRights/',
    NAME: 'SystemUserGroupSystemRights',
    ACTION_TYPES: {
        DELETE: 'DELETE_USERGROUP_RIGHT',
        CREATE: 'CREATE_USERGROUP_RIGHT',
        CREATE_LIST: 'CREATE_LIST_USERGROUP_RIGHTS',
    }
}

//FILE_DEVICE
export const FILE_DEVICE = {
    TAB_NAME: 'TabFileDevices/',
    NAME: 'FileDevices',
    ACTION_TYPES: {
        
    }
}
//FILE_PLANTPART
export const FILE_PLANTPART = {
    TAB_NAME: 'TabFilePlantParts/',
    NAME: 'FilePlantParts',
    ACTION_TYPES: {

    }
}
//FILE_PLANT
export const FILE_PLANT = {
    TAB_NAME: 'TabFilePlants/',
    NAME: 'FilePlants',
    ACTION_TYPES: {

    }
}
//FILE_FIRMA
export const FILE_FIRMA = {
    TAB_NAME: 'TabFileFirmas/',
    NAME: 'FileFirmas',
    ACTION_TYPES: {

    }
}

//FILESERVER 
export const FILESERVER = {
    TAB_NAME: 'TabFileServers/',
    NAME: 'FileServers',
    ACTION_TYPES: {
        DEVICE: {
            CREATE: 'CREATE_FILESERVER_FOR_DEVICE',
            DELETE: 'DELETE_FILESERVER_FOR_DEVICE',
            GET_LIST_OF_DOCUMENTS: 'GET_LIST_OF_DOCUMENTS_FILESERVER_FOR_DEVICE',
        },
        PLANTPART: {
            CREATE: 'CREATE_FILESERVER_FOR_PLANTPART',
            DELETE: 'DELETE_FILESERVER_FOR_PLANTPART',
            GET_LIST_OF_DOCUMENTS: 'GET_LIST_OF_DOCUMENTS_FILESERVER_FOR_PLANTPART',
        },
        PLANT: {
            CREATE: 'CREATE_FILESERVER_FOR_PLANT',
            DELETE: 'DELETE_FILESERVER_FOR_PLANT',
            GET_LIST_OF_DOCUMENTS: 'GET_LIST_OF_DOCUMENTS_FILESERVER_FOR_PLANT',
        },
        FIRMA: {
            CREATE: 'CREATE_FILESERVER_FOR_FIRMA',
            DELETE: 'DELETE_FILESERVER_FOR_FIRMA',
            GET_LIST_OF_DOCUMENTS: 'GET_LIST_OF_DOCUMENTS_FILESERVER_FOR_FIRMA',
        },
        PHYSICALLY: {
            SAVE: 'SAVE_FILESERVER_PHYSICALLY',
            DELETE: 'DELETE_FILESERVER_PHYSICALLY',
            DOWNLOAD: 'DOWNLOAD_FILESERVER_PHYSICALLY',
        },
        GET_FILES_TREE_BY_PLANT_GUID: 'GET_FILES_TREE_BY_PLANT_GUID_FILESERVER',
        GET_ALL_FILES_BY_FIRMA_GUID: 'GET_ALL_FILES_BY_FIRMA_GUID',
    },
    FILETYPE: {
        PDF: 'PDF',
        JPG: 'JPG',
        CSV: 'CSV',
        OTHER: 'OTHER',
    },
    DESCRIPTIONS: {
        DOCUMENT: 'DOCUMENT',
        DATA_SHEET: 'DATA_SHEET',
        MAINTENANCE_DOC: 'MAINTENANCE_DOC',
        EMERGENCY_PLAN: 'EMERGENCY_PLAN',
        SECURITY_CHECK: 'SECURITY_CHECK',
        LABORATORY_RESULT: 'LABORATORY_RESULT',
        CERTIFICATE: 'CERTIFICATE',
        IMAGE: 'IMAGE',
        EXPERT_REPORT:'EXPERT_REPORT',
    },
    FUNCTIONS: {
        getDocTypeBadgeColor: (type: string) => {
            switch (type) {
                case FILESERVER.DESCRIPTIONS.CERTIFICATE.replace('_', ' '):
                    return "secondary";
                case FILESERVER.DESCRIPTIONS.EMERGENCY_PLAN.replace('_', ' '):
                    return "success";
                case FILESERVER.DESCRIPTIONS.DATA_SHEET.replace('_', ' '):
                    return "light";
                case FILESERVER.DESCRIPTIONS.EXPERT_REPORT.replace('_', ' '):
                    return "info";
                case FILESERVER.DESCRIPTIONS.LABORATORY_RESULT.replace('_', ' '):
                    return "warning";
                case FILESERVER.DESCRIPTIONS.MAINTENANCE_DOC.replace('_', ' '):
                    return "dark";
                case FILESERVER.DESCRIPTIONS.SECURITY_CHECK.replace('_', ' '):
                    return "danger";
                case FILESERVER.DESCRIPTIONS.IMAGE.replace('_', ' '):
                    return "secondary";
                default:
                    return "primary";
            }
        },
        base64toBlob: (data) => {
            // Cut the prefix `data:application/pdf;base64` from the raw base 64
            const base64WithoutPrefix = data;//.substr('data:application/pdf;base64,'.length);



            const bytes = atob(base64WithoutPrefix);
            let length = bytes.length;
            let out = new Uint8Array(length);

            while (length--) {
                out[length] = bytes.charCodeAt(length);
            }

            return new Blob([out], { type: 'application/pdf', });
        },
        saveByteArray: (reportName, bytes) => {

            var file = FILESERVER.FUNCTIONS.base64toBlob(bytes);
            var fileURL = URL.createObjectURL(file);
            //
            var a = document.createElement("a");

            a.href = fileURL;
            a.download = reportName;
            a.target = '_blank';
            //a.onclick = () => "{window.open(" + fileURL + ",'_blank');return false;}";
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            window.URL.revokeObjectURL(fileURL);
            //
            //window.open(fileURL, '_blank');
        },
        viewByteArray: (reportName, bytes) => {

            var file = FILESERVER.FUNCTIONS.base64toBlob(bytes);
            var fileURL = URL.createObjectURL(file);
            window.open(fileURL, '_blank');
        },

    }
}

export const COLORS = {
    GREEN: {
        LIGHT: '#d4ede0',
        DARK: '#2b957a',
    },
    ORANGE: {
        LIGHT: '#ffe07f',
        DARK: 'darkorange',
    },
    RED: {
        LIGHT: '#ffcccb',
        DARK: 'red',
    },
    BLUE: {
        LIGHT: '#ccf3ff',
        DARK: 'darkblue',
        NORMAL: 'blue',
    },
    GRAY: {
        LIGHT: 'LIGHTGRAY',
        DARK: 'GRAY'
    },
    BLACK: 'black'
}



export const SMALL_ICON = {
    EMAIL: 'EMAIL',
    PERSON: 'PERSON',
    PHONE: 'PHONE',
    MOBILE: 'MOBILE',
    PLANT: 'PLANT',
    EXCLAMATION: 'EXCLAMATION',
    PLUG: 'PLUG',
    FIRMA: 'FIRMA',
    PLANTPART: 'PLANTPART',
    CALENDAR: 'CALENDAR',
    INFO: 'INFO',
    FILE:'FILE',
    CLOCK: 'CLOCK',
    DEVICE: 'DEVICE',
    DATAPOINT: 'DATAPOINT',
    NO_DATAPOINT: 'NO_DATAPOINT',
    HASH: 'HASH',
    PRODUCT: 'PRODUCT',
    NO_PRODUCT: 'NO_PRODUCT',
    NOTE: 'NOTE',
    CALC: 'CALC',
    X: 'X',
    NOT_PLUG: 'NOT_PLUG',
    TICK: 'TICK',
    CHECK_CIRCLE: 'CHECK_CIRCLE',
    EXCLAMATION_CIRCLE: 'EXCLAMATION_CIRCLE',
    USERGROUP: 'USERGROUP',
    USER: 'USER',
    USER_SUPERADMIN: 'USER_SUPERADMIN',
    USER_SYSADMIN: 'USER_SYSADMIN',
    USER_BERATER: 'USER_BERATER',
    USER_BERATER_CHECK: 'USER_BERATER_CHECK',
    ROLE: 'ROLE',
    RIGHT: 'RIGHT',
    LOCATION: 'LOCATION',
    TWOSIDESARROW: 'TWOSIDESARROW',
    GLOBE:'GLOBE',
    KEY: 'KEY',
    STOP: 'STOP',
    OKAY: 'OKAY',
    TOOLBOX:'TOOLBOX'
}

export const getSmallIcon = (name: string, size: number) => {
    switch (name) {
        case SMALL_ICON.TOOLBOX:
            return <em className={'fas fa-toolbox mx-' + size + " fa-sm"}></em>;
        case SMALL_ICON.GLOBE:
            return <em className={"fas fa-globe mx-" + size + " fa-sm"}></em>;
        case SMALL_ICON.CALC:
            return <em className={"fas fa-calculator mx-" + size + " fa-sm"}></em>;
        case SMALL_ICON.EMAIL:
            return <em className={"far fa-envelope mx-" + size + " fa-sm"}></em>;
        case SMALL_ICON.PERSON:
            return <em className={"fas fa-user mx-" + size + " fa-sm"}></em>;
        case SMALL_ICON.PHONE:
            return <em className={"fas fa-phone mx-" + size + " fa-sm"} ></em >;
        case SMALL_ICON.MOBILE:
            return <em className={"fas fa-mobile-alt mx-" + size + " fa-sm"} ></em >;
        case SMALL_ICON.PLANT:
            return <em className={"fas fa-industry mx-" + size + " fa-sm"} ></em >;
        case SMALL_ICON.EXCLAMATION:
            return <em className={"fas fa-exclamation mx-" + size + " fa-sm"} ></em >;
        case SMALL_ICON.PLUG:
            return <em className={"fas fa-plug mx-" + size + " fa-sm"} ></em >;
        case SMALL_ICON.FIRMA:
            return <em className={"far fa-building mx-" + size + " fa-sm"} ></em >;
        case SMALL_ICON.PLANTPART:
            return <em className={"fas fa-sitemap mx-" + size + " fa-sm"} ></em >;
        case SMALL_ICON.CALENDAR:
            return <em className={"far fa-calendar mx-" + size + " fa-sm"} ></em >;
        case SMALL_ICON.INFO:
            return <em className={"fas fa-info-circle mx-" + size + " fa-sm"} ></em >;
        case SMALL_ICON.CLOCK:
            return <em className={"fas fa-history mx-" + size + " fa-sm"} ></em>;
        case SMALL_ICON.DEVICE:
            return <em className={"fas fa-cogs mx-" + size + " fa-sm"} ></em>;
        //case SMALL_ICON.DATAPOINT:
        //    return <em className={"fa icon-speedometer mx-" + size + " fa-sm"} ></em>;
        case SMALL_ICON.DATAPOINT:
            return <em className={"fas fa-tachometer-alt mx-" + size + " fa-sm"} ></em>;
        case SMALL_ICON.NO_DATAPOINT:
            return <span className={"fa-stack"} style={{ left: 0 }}>
                <em className={"fa icon-speedometer fa-stack-1x"} ></em>
                <em className={"fas fa-slash fa-stack-1x"} style={{ color: "Tomato" }} ></em>
            </span>;
        case SMALL_ICON.HASH:
            return <em className={"fas fa-hashtag mx-" + size + " fa-sm"} ></em>;
        case SMALL_ICON.PRODUCT:
            return <em className={"fas fa-box-open mx-" + size + " fa-sm"} ></em>;
        case SMALL_ICON.NOTE:
            return <em className={"far fa-sticky-note mx-" + size + " fa-sm"} ></em>;
        case SMALL_ICON.X:
            return <em className={"fas fa-times mx-" + size + " fa-sm"} style={{ color: "Tomato" }} ></em>;
        case SMALL_ICON.NOT_PLUG:
            return <span className={"fa-stack"} style={{ left: 0 }}>
                <em className={"fas fa-plug fa-stack-1x" } ></em>
                <em className={"fas fa-slash fa-stack-1x"} style={{ color: "Tomato" }} ></em>
            </span>;
        case SMALL_ICON.NO_PRODUCT:
            return <span className={"fa-stack"} style={{ left: 0 }}>
                <em className={"fas fa-box-open fa-stack-1x"} ></em>
                <em className={"fas fa-slash fa-stack-1x"} style={{ color: "Tomato" }} ></em>
            </span>;
        case SMALL_ICON.EXCLAMATION_CIRCLE:
            return <em className={"fas fa-exclamation-circle mx-" + size + " fa-sm"} ></em>;
        case SMALL_ICON.CHECK_CIRCLE:
            return <em className={"fas fa-check-circle mx-" + size + " fa-sm"} ></em>;
        case SMALL_ICON.USERGROUP:
            return <em className={"fas fa-users mx-" + size + " fa-sm"} ></em>;
        case SMALL_ICON.USER:
            return <em className={"fas fa-user mx-" + size + " fa-sm"} ></em>;
        case SMALL_ICON.USER_BERATER:
            return <span className="fa-layers" >
                <FontAwesomeIcon icon="user" className=" fa-sm" />
                <FontAwesomeIcon icon="shield-alt" transform="shrink-12 down-4 left-2" inverse />
            </span>;
        case SMALL_ICON.USER_BERATER_CHECK:
            return <span className="fa-layers" >
                <FontAwesomeIcon icon="user-check" className=" fa-sm" />
            </span>;
        case SMALL_ICON.USER_SUPERADMIN:
            return <span className="fa-layers" >
                <FontAwesomeIcon icon="user-tie" className=" fa-sm" />
            </span>;
        case SMALL_ICON.USER_SYSADMIN:
            return <span className="fa-layers" >
                <FontAwesomeIcon icon="user" className=" fa-sm" />
                <FontAwesomeIcon icon="award" transform="shrink-12 down-4 left-2" inverse />
            </span>;
        case SMALL_ICON.RIGHT:
            return <em className={"far fa-check-circle mx-" + size + " fa-sm"} ></em>;
        case SMALL_ICON.ROLE:
            return <em className={"fas fa-user-tag mx-" + size + " fa-sm"} ></em>;
        case SMALL_ICON.LOCATION: 
            return <em className={"fas fa-map-marker mx-" + size + " fa-sm"} ></em>;
        case SMALL_ICON.TWOSIDESARROW: 
            return <em className={"fas fa-arrows-alt-h mx-" + size + " fa-sm"} ></em>;
        case SMALL_ICON.TICK:
            return <em className={"fas fa-check mx-" + size + " fa-sm"} style={{ color: "green" }} ></em>;
        case SMALL_ICON.KEY:
            return <em className={"fas fa-key mx-" + size + " fa-sm"} ></em>;
        case SMALL_ICON.STOP:
            return <em className={"far fa-hand-paper mx-" + size + " fa-sm"} ></em>;
        case SMALL_ICON.OKAY:
            return <em className={"far fa-thumbs-up mx-" + size + " fa-sm"} ></em>;
        case SMALL_ICON.FILE:
            return <em className={"fas fa-file mx-" + size + " fa-sm"} ></em>;
    }

}

export const GENERAL = {
    REPORT: {
        getStatusImage: (status, t) => {
            switch (status) {
                case SYSTEMUSER.STATUS.ACTIVE:
                    return 'https://dummyimage.com/100x50/59c745/fff&text=' + t(TRANS.REPORT_MANAGER.STATUS.ACTIVE);
                case SYSTEMUSER.STATUS.INACTIVE:
                    return 'https://dummyimage.com/100x50/c74545/fff&text=' + t(TRANS.REPORT_MANAGER.STATUS.INACTIVE);
                case SYSTEMUSER.STATUS.SUSPENDED:
                    return 'https://dummyimage.com/100x50/FFA500/fff&text=' + t(TRANS.REPORT_MANAGER.STATUS.SUSPENDED);
            }
        },
        STATUS: {
            ACTIVE: 'ACTIVE',
            INACTIVE: 'INACTIVE',
            SUSPENDED: 'SUSPENDED',
        },
    },
    PLANT: {
        getConnectionIcons: (status: PlantStatus_Type, t : (string) => string) => {
            switch (status) {
                case PLANT.STATUS.ACTIVE: return <span style={{ color: COLORS.GREEN.DARK }} title={t(TRANS.PLANT.ACTIVE)}>{getSmallIcon(SMALL_ICON.CHECK_CIRCLE, 2)}</span>;
                case PLANT.STATUS.INACTIVE: return <span style={{ color: COLORS.RED.DARK }} title={t(TRANS.PLANT.INACTIVE)}>{getSmallIcon(SMALL_ICON.EXCLAMATION_CIRCLE, 2)}</span>;
                default: return <span></span>;
            }
        },
        getStatusImage: (status, t) => {
            switch (status) {
                case PLANT.STATUS.ACTIVE:
                    return 'https://dummyimage.com/100x50/59c745/fff&text=' + t(TRANS.PLANT.ACTIVE);
                case PLANT.STATUS.INACTIVE:
                    return 'https://dummyimage.com/100x50/c74545/fff&text=' + t(TRANS.PLANT.INACTIVE);
            }
        },
        getPlantCount: (plantListInOneFirma: PlantObj[], user: LoginUserObj) => {
            if (!user)
                return -1;
            if (!plantListInOneFirma)
                return -1;
            if (plantListInOneFirma.length === 0)
                return 0;
            //super admin
            if (user.isSuperAdmin)
                return plantListInOneFirma.length;
            //system admin
                //console.log("222", plantListInOneFirma[0].firmaId);
            //var oneFirmaPlantsList = Object.values(user.Memberships).filter(x => x.FirmaID === plantListInOneFirma[0].firmaId);
            var oneFirmaPlantsList = Object.keys(user!.Memberships ?? []).filter(key => user !== undefined && user.Memberships !== undefined && user.Memberships[key] !== undefined && user.Memberships[key].FirmaID === plantListInOneFirma[0].FirmaID);
                //console.log("333", oneFirmaPlantsList);
            let rrr = -1;
            oneFirmaPlantsList.forEach((membership_key, ind) => {
                //console.log("membership1", membership.Roles.some(x => x === ROLE.IDs.SYSTEMADMIN_ROLE_ID));
                //console.log("membership2", membership);
                if (user.Memberships && user.Memberships[membership_key].Roles.some(x => x === ROLE.IDs.SYSTEMADMIN_ROLE_ID))
                    rrr = plantListInOneFirma.length;
            })
                //console.log("rrr value", rrr);
            if (rrr > 0)
                return rrr;
            //other cases
                //console.log("44", plantListInOneFirma[0].firmaId);
            //console.log("444", Object.values(user.Memberships).filter(x => x.FirmaID === plantListInOneFirma[0].firmaId));
            if (user.Memberships)
                return Object.keys(user.Memberships).filter(key => user && user.Memberships && user.Memberships[key].FirmaID === plantListInOneFirma[0].FirmaID).length;
            return -1;
        } 
    },
    PLANTPART: {
        getConnectionIcons: (status, t) => {
            switch (status) {
                case PLANTPART.STATUS.ACTIVE: return <span style={{ color: COLORS.GREEN.DARK }} title={t(TRANS.PLANTPART.ACTIVE)}>{getSmallIcon(SMALL_ICON.CHECK_CIRCLE, 2)}</span>;
                case PLANTPART.STATUS.INACTIVE: return <span style={{ color: COLORS.RED.DARK }} title={t(TRANS.PLANTPART.INACTIVE)}>{getSmallIcon(SMALL_ICON.EXCLAMATION_CIRCLE, 2)}</span>;
                default: return <span></span>;
            }
        },
        getStatusImage: (status, t) => {
            switch (status) {
                case PLANTPART.STATUS.ACTIVE:
                    return 'https://dummyimage.com/100x50/59c745/fff&text=' + t(TRANS.PLANTPART.ACTIVE);
                case PLANTPART.STATUS.INACTIVE:
                    return 'https://dummyimage.com/100x50/c74545/fff&text=' + t(TRANS.PLANTPART.INACTIVE);
            }
        }
    },
    DEVICE: {
        getConnectionIcons: (status, t) => {
            switch (status) {
                case DEVICE.STATUS.ACTIVE: return <span style={{ color: COLORS.GREEN.DARK }} title={t(TRANS.DEVICE.ACTIVE)}>{getSmallIcon(SMALL_ICON.CHECK_CIRCLE, 2)}</span>;
                case DEVICE.STATUS.INACTIVE: return <span style={{ color: COLORS.RED.DARK }} title={t(TRANS.DEVICE.INACTIVE)}>{getSmallIcon(SMALL_ICON.EXCLAMATION_CIRCLE, 2)}</span>;
                default: return <span></span>;
            }
        },
        getStatusImage: (status,t) => {
            switch (status) {
                case DEVICE.STATUS.ACTIVE:
                    return 'https://dummyimage.com/100x50/59c745/fff&text=' + t(TRANS.DEVICE.ACTIVE);
                case DEVICE.STATUS.INACTIVE:
                    return 'https://dummyimage.com/100x50/c74545/fff&text=' + t(TRANS.DEVICE.INACTIVE);
            }
        }
    },
    DATAPOINT: {
        getConnectionIcons: (status,t) => {
            switch (status) {
                case DATAPOINT.STATUS.ACTIVE: return <span style={{ color: COLORS.GREEN.DARK }} title={t(TRANS.DATAPOINT.ACTIVE)}>{getSmallIcon(SMALL_ICON.CHECK_CIRCLE, 2)}</span>;
                case DATAPOINT.STATUS.INACTIVE: return <span style={{ color: COLORS.RED.DARK }} title={t(TRANS.DATAPOINT.INACTIVE)}>{getSmallIcon(SMALL_ICON.EXCLAMATION_CIRCLE, 2)}</span>;
                default: return <span></span>;
            }
        },
        getStatusImage : (status,t) => {
            switch (status) {
                case DATAPOINT.STATUS.ACTIVE:
                    return 'https://dummyimage.com/100x50/59c745/fff&text=' + t(TRANS.DATAPOINT.ACTIVE);
                case DATAPOINT.STATUS.INACTIVE:
                    return 'https://dummyimage.com/100x50/c74545/fff&text=' + t(TRANS.DATAPOINT.INACTIVE);
            }
        }
    },
    MAINTENANCEPLAN: {
        getStatusImage: (status,t) => {
            switch (status) {
                case MAINTENANCEPLAN.STATUS.ACTIVE:
                    return 'https://dummyimage.com/100x50/59c745/fff&text=' + t(TRANS.MAINTENANCEPLAN.ACTIVE);
                case MAINTENANCEPLAN.STATUS.INACTIVE_NON_PERIODIC:
                    return 'https://dummyimage.com/100x50/a6a6a6/000000&text=' + t(TRANS.MAINTENANCEPLAN.INACTIVE);
                case MAINTENANCEPLAN.STATUS.INACTIVE_PERIODIC:
                    return 'https://dummyimage.com/100x50/a6a6a6/000000&text=' + t(TRANS.MAINTENANCEPLAN.INACTIVE);
                case MAINTENANCEPLAN.STATUS.PASSED:
                    return 'https://dummyimage.com/100x50/ff0000/ffffff&text=' + t(TRANS.MAINTENANCEPLAN.PASSED);
                case MAINTENANCEPLAN.STATUS.VERYCLOSE:
                    return 'https://dummyimage.com/100x50/ffa600/000000&text=' + t(TRANS.MAINTENANCEPLAN.VERYCLOSE);
            }
        },
        getMPIcon: MPtype => {
            switch (MPtype) {
                case MAINTENANCEPLAN.TYPES.ALL_DEVICES: return "fas fa-wrench";
                case MAINTENANCEPLAN.TYPES.DEVICE: return "fas fa-wrench";
                case MAINTENANCEPLAN.TYPES.PLANT_PART: return "fas fa-stethoscope";
                default: return '';
            }
        },
        getMPColor: status => {
            switch (status) {
                case MAINTENANCEPLAN.STATUS.ACTIVE:
                    return COLORS.GREEN.LIGHT;
                case MAINTENANCEPLAN.STATUS.VERYCLOSE:
                    return COLORS.ORANGE.LIGHT;
                case MAINTENANCEPLAN.STATUS.PASSED:
                    return COLORS.RED.LIGHT;
                case MAINTENANCEPLAN.STATUS.INACTIVE_NON_PERIODIC:
                    return COLORS.GRAY.LIGHT;
                case MAINTENANCEPLAN.STATUS.INACTIVE_PERIODIC:
                    return COLORS.BLUE.LIGHT;
                default:
                    return '';
            }
        },
        getBreadcrumbLevel_Add: ContentType => {
            switch (ContentType) {
                case MAINTENANCEPLAN.TYPES.PLANT_PART:
                    return BREADCRUMB_LEVELS.MAINTENANCEPLAN_PLANTPART_ADD;
                case MAINTENANCEPLAN.TYPES.DEVICE:
                    return BREADCRUMB_LEVELS.MAINTENANCEPLAN_DEVICE_ADD;
                case MAINTENANCEPLAN.TYPES.ALL_DEVICES:
                    return BREADCRUMB_LEVELS.MAINTENANCEPLAN_ALLDEVICE_ADD;
                default:
                    return "BREADCRUMB_LEVELS getMPRows ERROR";

            }
        },
        getBreadcrumbLevel_List: ContentType => {
            switch (ContentType) {
                case MAINTENANCEPLAN.TYPES.PLANT_PART:
                    return BREADCRUMB_LEVELS.MAINTENANCEPLAN_PLANTPART_LIST;
                case MAINTENANCEPLAN.TYPES.DEVICE:
                    return BREADCRUMB_LEVELS.MAINTENANCEPLAN_DEVICE_LIST;
                case MAINTENANCEPLAN.TYPES.ALL_DEVICES:
                    return BREADCRUMB_LEVELS.MAINTENANCEPLAN_ALLDEVICE_LIST;
                default:
                    return "BREADCRUMB_LEVELS getMPRows ERROR";

            }
        },
        getSliderColor: (status, muiTheme) => {
            if (status)
                switch (status.toUpperCase()) {
                    case MAINTENANCEPLAN.STATUS.PASSED: return muiTheme(COLORS.RED.DARK);
                    case MAINTENANCEPLAN.STATUS.VERYCLOSE: return muiTheme(COLORS.ORANGE.DARK);
                    case MAINTENANCEPLAN.STATUS.ACTIVE: return muiTheme(COLORS.GREEN.DARK);
                    case MAINTENANCEPLAN.STATUS.INACTIVE_PERIODIC: return muiTheme(COLORS.BLUE.DARK);
                    case MAINTENANCEPLAN.STATUS.INACTIVE_NON_PERIODIC: return muiTheme(COLORS.GRAY.DARK);
                    default: return muiTheme(COLORS.BLUE.DARK);
                }
        },
        getStatus_Add: (active, periodic, deadlineType, dueDate, remindingBeforeDays, currentOpHo ,operatingHoursDeadline, remindBeforeHours) => {
            if (!active && !periodic)
                return MAINTENANCEPLAN.STATUS.INACTIVE_NON_PERIODIC;
            if (!active && periodic)
                return MAINTENANCEPLAN.STATUS.INACTIVE_PERIODIC;

            // 0 for passed | 1 for veryclosed | 2 for active
            var TimeStat = -1;
            var OperatingHoursStat = -1;
            //For Time
            if (deadlineType === GENERAL.MAINTENANCEPLAN.TIMING.ONLY_TIME || deadlineType === GENERAL.MAINTENANCEPLAN.TIMING.TIME_AND_OPERATINGHOURS)
            {
                if (active) {
                    const dateDueDate = new Date(dueDate);
                    const today = new Date();

                    if (!remindingBeforeDays || remindingBeforeDays === undefined)
                        remindingBeforeDays = 0;
                    let remindingDate = new Date(dueDate);
                    if (remindingBeforeDays !== 0)
                        remindingDate.setTime(dateDueDate.getTime() - (remindingBeforeDays * 24 * 60 * 60 * 1000));

                    if (today < remindingDate)
                        TimeStat = 2;
                    else if (today < dateDueDate)
                        TimeStat = 1;
                    else
                        TimeStat = 0;
                }
            }
            //For Operating Hours
            if (deadlineType === GENERAL.MAINTENANCEPLAN.TIMING.ONLY_OPERATINGHOURS || deadlineType === GENERAL.MAINTENANCEPLAN.TIMING.TIME_AND_OPERATINGHOURS) {
                if (active) {
                    if (currentOpHo < remindBeforeHours)
                        OperatingHoursStat = 2;
                    else if (currentOpHo < operatingHoursDeadline)
                        OperatingHoursStat = 1;
                    else
                        OperatingHoursStat = 0;
                }
            }
            //Final State
            if (TimeStat === OperatingHoursStat && TimeStat === -1) // error case: both are -1
                return GENERAL.MAINTENANCEPLAN.int2MPState(-1);
            if (TimeStat === -1) // Only Operating Hours
                return GENERAL.MAINTENANCEPLAN.int2MPState(OperatingHoursStat);
            if (OperatingHoursStat === -1) // Only Time
                return GENERAL.MAINTENANCEPLAN.int2MPState(TimeStat);
            //Time and Operating Hours case
            return GENERAL.MAINTENANCEPLAN.int2MPState(TimeStat < OperatingHoursStat ? TimeStat : OperatingHoursStat);
        },
        getStatus_Edit: (active, periodic, done, deadlineType, dueDate, remindingBeforeDays, currentOH, operatingHoursDeadline, remindBeforeHours) => {
            //if (done) ==> inactive
            if (done && periodic)
                return MAINTENANCEPLAN.STATUS.INACTIVE_PERIODIC;
            if (done && !periodic)
                return MAINTENANCEPLAN.STATUS.INACTIVE_NON_PERIODIC;
            //if (not done) && (not active)
            if (!active && periodic)
                return MAINTENANCEPLAN.STATUS.INACTIVE_PERIODIC;
            if (!active && !periodic)
                return MAINTENANCEPLAN.STATUS.INACTIVE_NON_PERIODIC;

            // 0 for passed | 1 for veryclosed | 2 for active
            var TimeStat = -1;
            var OperatingHoursStat = -1;
            //For Time
            if (deadlineType === GENERAL.MAINTENANCEPLAN.TIMING.ONLY_TIME || deadlineType === GENERAL.MAINTENANCEPLAN.TIMING.TIME_AND_OPERATINGHOURS) {
                //if (active)
                if (active) {
                    const dateDueDate = new Date(dueDate);
                    const today = new Date();

                    if (!remindingBeforeDays || remindingBeforeDays === undefined)
                        remindingBeforeDays = 0;
                    let remindingDate = new Date(dueDate);
                    if (remindingBeforeDays !== 0)
                        remindingDate.setTime(dateDueDate.getTime() - (remindingBeforeDays * 24 * 60 * 60 * 1000));

                    if (today < remindingDate)
                        TimeStat = 2;
                    else if (today < dateDueDate)
                        TimeStat = 1;
                    else
                        TimeStat = 0;
                }
            }
            //For Operating Hours
            if (deadlineType === GENERAL.MAINTENANCEPLAN.TIMING.ONLY_OPERATINGHOURS || deadlineType === GENERAL.MAINTENANCEPLAN.TIMING.TIME_AND_OPERATINGHOURS) {
                if (active) {
                    if (currentOH < operatingHoursDeadline - remindBeforeHours)
                        OperatingHoursStat = 2;
                    else if (currentOH < operatingHoursDeadline)
                        OperatingHoursStat = 1;
                    else
                        OperatingHoursStat = 0;
                }
                console.log("" + currentOH + "<" + remindBeforeHours, currentOH < remindBeforeHours);
                console.log("" + currentOH + "<" + operatingHoursDeadline, currentOH < operatingHoursDeadline);
                console.log("operatingHoursDeadline",operatingHoursDeadline);
            }
            //Final State
            if (TimeStat === OperatingHoursStat && TimeStat === -1) // error case: both are -1
                return GENERAL.MAINTENANCEPLAN.int2MPState(-1);
            if (TimeStat === -1) // Only Operating Hours
                return GENERAL.MAINTENANCEPLAN.int2MPState(OperatingHoursStat);
            if (OperatingHoursStat === -1) // Only Time
                return GENERAL.MAINTENANCEPLAN.int2MPState(TimeStat);
            //Time and Operating Hours case
            return GENERAL.MAINTENANCEPLAN.int2MPState(TimeStat < OperatingHoursStat ? TimeStat : OperatingHoursStat);
        },
        int2MPState: number => {
            switch (number) {
                case 0: return MAINTENANCEPLAN.STATUS.PASSED;
                case 1: return MAINTENANCEPLAN.STATUS.VERYCLOSE;
                case 2: return MAINTENANCEPLAN.STATUS.ACTIVE;
                default: return 'ERROR IN MAINTENANCEPLAN STATUS'; 
            }
        },
        getFilterText: (filter, sum) => {
            if (filter && sum !== undefined)
                return filter + " [" + sum + "]";
            return "ERROR IN FILTER";
        },
        TIMING: {
            ONLY_TIME: 'Time',
            ONLY_OPERATINGHOURS: 'Hours',
            TIME_AND_OPERATINGHOURS: 'TimeHours',
        },
        getNotifyingMedia: (notifyingMedia,t) => {
            switch (notifyingMedia) {
                case 0: return t(TRANS.MAINTENANCEPLAN.TIMING.MEDIA.NONE);
                case 1: return t(TRANS.MAINTENANCEPLAN.TIMING.MEDIA.EMAIL);
                case 2: return t(TRANS.MAINTENANCEPLAN.TIMING.MEDIA.SMS);
                default: return t(TRANS.MAINTENANCEPLAN.TIMING.MEDIA.NOT_DETERMINED);
            }
        },
        getRemindingMedia: (remindingMedia,t) => {
            switch (remindingMedia) {
                case 0: return t(TRANS.MAINTENANCEPLAN.TIMING.MEDIA.NONE);
                case 1: return t(TRANS.MAINTENANCEPLAN.TIMING.MEDIA.EMAIL);
                case 2: return t(TRANS.MAINTENANCEPLAN.TIMING.MEDIA.SMS);
                default: return t(TRANS.MAINTENANCEPLAN.TIMING.MEDIA.NOT_DETERMINED);
            }
        },
        getNextInterval: (periodType, interval) => {
            //console.log('getNextPeriodDate ' + periodType + ' - ' + interval, oldDate);
            switch ('' + periodType) {
                case '1': return interval;
                case '2': return (interval * 7);
                case '3': return interval;
            }
        },
        getPeriodicityType2Int: type => {
            switch (type) {
                case MAINTENANCEPLAN.PERIODICITY_TYPE.DAY: return 1;
                case MAINTENANCEPLAN.PERIODICITY_TYPE.WEEK: return 2;
                case MAINTENANCEPLAN.PERIODICITY_TYPE.MONTH: return 3;
            }
        },
        getInt2PeriodicityType: (typeInt,t) => {
            switch ('' + typeInt) {
                case '1': return t(TRANS.MAINTENANCEPLAN.TIMING.DAY);
                case '2': return t(TRANS.MAINTENANCEPLAN.TIMING.WEEK);
                case '3': return t(TRANS.MAINTENANCEPLAN.TIMING.MONTH);
            }
        }
    },
    SYSTEMUSER: {
        getStatusImage: status => {
            switch (status) {
                case SYSTEMUSER.STATUS.ACTIVE:
                    return 'https://dummyimage.com/100x50/59c745/fff&text=Active';
                case SYSTEMUSER.STATUS.INACTIVE:
                    return 'https://dummyimage.com/100x50/c74545/fff&text=Inactive';
                case SYSTEMUSER.STATUS.SUSPENDED:
                    return 'https://dummyimage.com/100x50/FFA500/fff&text=Suspended';
            }
        },
        isSuperAdmin: userJWT => {
            if (userJWT.isSuperAdmin)
                return true;
            return false;
        },
        getCompaniesCount: (tabSystemUserSystemUserGroupPlant: SystemUserSystemUserGroupPlantObj[]) => {
            var coms = [] as string[];
            console.log("tabSystemUserSystemUserGroupPlant", tabSystemUserSystemUserGroupPlant);
            tabSystemUserSystemUserGroupPlant.forEach((record, indx) => {
                
                if (!coms.some(x => record && record.plant && record.plant.FirmaID && x === record.plant.FirmaID))
                    if (record && record.plant && record.plant.FirmaID)
                        coms.push(record.plant.FirmaID);
            });
            return coms.length;
        },
    }
}


export const FUNCTIONS = {
    getDateForInputElemet: (someDate: Date | undefined) => {
        if (!someDate)
            return '';
        else if (someDate) {
            var dd = new Date(someDate.toString());
            var mon = dd.getMonth() + 1;
            return dd.getFullYear() + '-' + (mon < 10 ? '0' + mon : mon) + '-' + (dd.getDate() < 10 ? '0' + dd.getDate() : dd.getDate());
        }
    }
}

export const ADMIN_IMG = {
    NULL: null,
    DETERMINE_BGA: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAARgAAABlCAYAAACWRfwnAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsQAAA7EAZUrDhsAAAppSURBVHhe7d07jOPGGQfw79KdkfiBIJfYPgN5UIvk7hI7CBADlIsArqRrttrWHVVKjbsrr7tGKled2622WaqKgQBZBU5hx8n6HCyZS4I7XHAxkjgP2O6UGWq4S84MX9IMVyT/P2Bwko4cUZT48ZsHuddWDAEAWPA18S8AgHEIMABgDQIMAFiDAAMA1iDAAIA1CDAAYA0CDABYgwADANYgwACANQgwAGANAgwAWIMAAwDWIMAAgDUIMABgjdEA8/TZZ/Tb331Ci/dP6dq1a0bKr37zIX3+n/+JdwCAJjF2PxgeBF564RvimXn/+vd/6cXnvy6eAUATGMtgzh/9VTyy4+NPzsUjAGgKYxkMb87YhpvvATQLOnkBwBoEGACwBgEGAKxBgAEAaxBgAMAaBBgAsAYBBgCsQYABAGsQYADAGgQYALAGAQYArEGAAQBrEGAAwBoEGACwBgEGAKxBgAEAazp/wyl+H+Enf/s7/eOfn9Nz16/TzZdv0A++e1P8r3l/+suTi7v/8fd7/fYebgUKrdXpAMNvKP4L92fi2aXffxrQj3/oiGdm8EDGb/s5fPst8col3G8Y2qqTAYZnEc73XhPP9Ewe9FmBLPbBR2f08zdui2cA7dGpAMP/8gHPIvIO9lj458dbN5XKBLKYqeAJsEs608nLD3b+Z1XKBBfui6++Eo+q44GMZy1lgwtAW7U+wPC+jzoP9j/8MawUyADarNUBhh/sr37nRi0HexzIfvKjnngFAFoZYPjBzv98bV0HO/9zuXUFMoAmaV2A4VkEP9h1w8GmxYHszZ/eEa8AQFJrAgzvxOUjWXVlEXUGMoCmanyAqXvEpu5ABtBkjQ4wVYeet4GhZ4DqGhlgMPQM0AyNm8nLD/Y6Rof49UjffOkFCh49riWwYCYvtFGjMpg6h56fPH2GoWeALTUqg2kzZDDQRq0ZpgaA3YMAAwDWIMA02GLUj5qm2aVP/f6IZouQQrFOOWz5xYxGfba+XCd/bVS1zgWrS6qHbdtoIf57Q+FM/fz93EpDts8Sy7Nlq+0XqIz3wZjAq9q54nqr6dRfBUEgtlJgzwN/uvJcV7/eFZTqgtXU1delLWxf+NJuUAUrf+qtXN362uKuvOJKVyvf06zLiueLBTaR/fndadY2Seu4U/YK2NTaAFPqh88F0woHlL1SXcUAExUWZMTaqk3q4yWvzjXf063Hi7vKjAWFcrY3M3AgwNStpU0kj/YHJe+p64zpdOWzNZrOJXawRqNR6xKQz46mtDkda1sQIc36PZosxVPBdT3ygyBRJyvsOcty2LvFzug8r50Rzuj+XDxWLOnoxEIjZTmhB1s2v8AM9MFEBnTITrPt4tBgfEryxzrTRINw9o4SXFgGSKenhzRwpEDNng/Ghyworyhglbt0h/ZyYnl4csTCSIwFQX+aCE4sFhydmOkHcd1UvfP7M/Sv7ICWBpj1WTUMFzQbSR2VvNNT98sbvEvKCb8TFvRAii7uNKDDEhmgM+CBhgUh8VwV0slRom73gO4O7tJBOsKQmSTmgO4lv8AtshjewR39bjQd03GnuR77vV2s02fLrV9dd5hL9UgdzHGnet4yWmFIi9lI2dbNOvctYGmvEbyq5hR92z+7r8B+qU7ug9B9JrWfQulXlTtgTfZLSP1bcedrME13rmd3yubR9KfI/WnKZynqg/GV/ZVZtPvJX7GE8WIZ3g+YW19UR8C+gpzBBu37rLEMsrj/kHfui+WvQkcDDCuaEQz5h19nqa4owGh+uJrPLAfVzQ52vfT+TGxfYSAoQx8s5M+T/sgFAaZih7+6r9IBxlTRfidZI3O6stH+NaO7fTBn5y1roy9p0kumyT0azhO9H55PwaHcmAnp/Ew8FO7kdahUomkexVU7tppJvKWb7uOp1Bfj7FF0b0LXo+mU7a+CTvOy/UcuryuuI6OrL/p+MpZR32dBo2Gy55xtb7Iznj2eJuu4yk5vtkFG8KoaVVqXwRQUVzdnRT7jappZRWf1rLNjRvMopuxrzfeRLzsbyc5iCjKYQvL+kpsfagajZB+a/cmCi/jPWMH7SNmLftdJdVTev2Z0NoPx9tWzeeqM2zbLJc2HPepre7hzBA8To0Aay4cUiIdJiweT1OjRwUX6subcPUhlGjQ/ZudlM7bKYnL16FZqo4t4dG8sZYRxlnSBLaNklvL7pKcCLI7T4/7zYTJzjcuQUktdUcbevQDD01+fj5KI57HwhJodX+R5MDxV9lmqnD4ilpN3EqNo8g95SQ/laNG7lQ4EpSwodQwkm0cxuZmUOUdnA86Y3ks2Zyo3wdYjM+qlEupcoeqqBimZ2qzdZd0IMBftW1ZOD2msGYJNn3FbwhnQ+PA9afg9ObnNoT3pDyIo82SiiYiJoFVmUuLiOH32XE6olzpQ9Qfr3FiE4Zt9L7GdS5qU7IQI+ZAv77+azGnOsr62/CbcO3vs265fJwKMe6uXs3P5BXB9SvWZtYpDd9OpAmvVXKYpPel0amLim5zCl2awmcQnT76bjKzz+/r5T0mLEfVYYGlWUNFkrppyqqTs9ejuKBI7jNaTm9KjLW3kyGlKgtIXsvWIg9Q8qsRgM4mRs5ijE11v0SU5MEYjO9JIUjobvApy1qlp1u6QbgaYcBalwb3hhKXB4rUWUw4cltFdYE2ge1KbZz7sF5/ts0jNI3cqXcskFXlI1mQzSc5ilpP7dCQeq+S+jXXnq3ylxC6Qs06z+8ysbgaYopGR1tA1/9QRncGh3K+ynlPTH81oESYjDc/6jimvj1EOZkXzagb7coQp0ZSpQM5ilqW/eJ5NJTYk5Pe0MdHJuz11BG4ovivxPMK+K3GpTHTZgsF9Wgk7ixjBq9rVosxFqDILsqZSXcV5MKJoZ4VyFWexXpbEHA2ljjLT1EvMHdEqP6clc36TtE71eVBF82B0n1/+3soso85PqratustI6tGJDCbZqcmF5+JBp7jksebKqTwvI8ZHizTD2oXcWxQ3uNJXTjPefs6FkLEByUmMsSusBWcsj6TplVnOdSvuH0uc6Er5stuSf8W7VSLQbI1XhbJ52UTuRXJRcVeu6608flc/sU4pwfrOdvyOf+wnnK6TvxbXKVXqp86q7KxZnL6sKRftlcl8+LVWiXW8gs/Isit2PCbeIytT4nc7ZNsjLxvdEZAt7yezNDWDkbMqXXaS2u4yy/D3yfpwAXtP9juQtzf+7qM7OopFrwL+bMmOMPQ1AOyUbnTyetPLiXasBKkrwQDAlk4EGG9/nJpo54y7enMpgHp1IMC4lJz2AQD16eY8GACoRQcCDL/QLX25fjh7sBMTpgDaDqNIOwKjSNBGaCIBgDXGAoz/y1+LR1AV9h20lbEA89z16+IRVIV9B21lLMC8fnsPZ+IN9b7/mngE0C7GOnm5p88+o+DRY/riyy9p+PZb4lXI8sFHZ3Tz5Rv0yre/JV4BaBejAQYAIAmjSABgDQIMAFiDAAMA1iDAAIA1CDAAYA0CDABYgwADANYgwACANQgwAGANAgwAWIMAAwDWIMAAgDUIMABgDQIMAFiDAAMAlhD9Hy9411kfPUUcAAAAAElFTkSuQmCC',
    PREPARE_KEYVALUE: 'data:image/png;base64,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',
    LINK_SERVER: 'data:image/png;base64,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',
    INSERT_INTO_KEYVALUE: 'data:image/png;base64,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',
    SYNC_WITH_LOCAL: 'data:image/png;base64,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',
    SELECT_FROM_RTIP: 'data:image/png;base64,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',
    RESTART_OPC: 'data:image/png;base64,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',
    TECH_NAME_OPC_UI: 'data:image/png;base64,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',
}


export const TRANS = {
    LANGUAGE: {
        DEFAULT: 'en',
        i18n: {
            EN: 'en',
            DE: 'de'
        },
        langButton: {
            EN: "US",
            DE: "DE"
        }
    },
    NAV: {
        DASHBOARD: "NAV.DASHBOARD",
        PERMISSIONS: "NAV.PERMISSIONS",
        USERMANAGER: "NAV.USERMANAGER",
        PRODUCTMANAGER: "NAV.PRODUCTMANAGER",
        DAILYVALUESREPORTS: "NAV.DAILYVALUESREPORTS",
        WPLIST: "NAV.WPLIST",
        DOCUMENTSERVER: "NAV.DOCUMENTSERVER",
        TRENDS: "NAV.TRENDS",
        ADMINISTRATION: "NAV.ADMINISTRATION",
        HOWTO: "NAV.HOWTO",
        PORTALEMAIL: "NAV.PORTALEMAIL",
        REPORTS_MAIN_MENU: "NAV.REPORTS_MAIN_MENU",
        REPORTMANAGER: "NAV.REPORTMANAGER",
    },
    LOGIN: {
        VERSION_NAME: "LOGIN.VERSION_NAME",
        SIGN_IN_TO_CONTINUE: "LOGIN.SIGN_IN_TO_CONTINUE",
        FORGOT_YOUR_PASS: "LOGIN.FORGOT_YOUR_PASS",
        LOGIN: "LOGIN.LOGIN",
        NEED_TO_SIGN_UP: "LOGIN.NEED_TO_SIGN_UP",
        REGISTER_NOW: "LOGIN.REGISTER_NOW",
        OLD_PORTAL_LINK: "LOGIN.OLD_PORTAL_LINK"
    },
    DASHBOARD: {
        UNKNOWN: "DASHBOARD.UNKNOWN",
        HELLO: "DASHBOARD.HELLO",
        WELCOME:"DASHBOARD.WELCOME"
    },
    ACTIONS: {
        VIEW_DETAILS: 'ACTIONS.VIEW_DETAILS',
        VIEW:'ACTIONS.VIEW',
        DELETE: 'ACTIONS.DELETE',
        EDIT: 'ACTIONS.EDIT',
        LOADING: 'ACTIONS.LOADING',
        SEARCH: 'ACTIONS.SEARCH',
        FILTER: 'ACTIONS.FILTER',
        FILTERS: 'ACTIONS.FILTERS',
        SORT: 'ACTIONS.SORT',
        CLOSE: "ACTIONS.CLOSE",
        STOP: "ACTIONS.STOP",
        SHOW_REPORT: "ACTIONS.SHOW_REPORT",
        HIDE_REPORT: "ACTIONS.HIDE_REPORT",
        CHANGE_DISPLAY_MODE: 'ACTIONS.CHANGE_DISPLAY_MODE',
        LOGOUT: "ACTIONS.LOGOUT",
        STRUCTURE: "ACTIONS.STRUCTURE",
        EXPORT: "ACTIONS.EXPORT",
        CLOSE_STRUCTURE: "ACTIONS.CLOSE_STRUCTURE",
        UPLOAD: "ACTIONS.UPLOAD",
        DOWNLOAD: "ACTIONS.DOWNLOAD",
        SELECT:"ACTIONS.SELECT",
    },
    BUTTONS: {
        ADD: 'BUTTONS.ADD',
        CANCEL: 'BUTTONS.CANCEL',
        SAVE_CHANGES: 'BUTTONS.SAVE_CHANGES',
        YES: "BUTTONS.YES",
        NO: "BUTTONS.NO",
        NEXT: "BUTTONS.NEXT",
        BACK: "BUTTONS.BACK",
        SEND: "BUTTONS.SEND",
        DELETE: "BUTTONS.DELETE",
    },
    MESSAGES: {
        DELETE_ASK_TO_CONFIRM: "MESSAGES.DELETE_ASK_TO_CONFIRM",
    },
    TARGETACTUALSUMMARY: {
        TOTAL_OF: "TARGETACTUALSUMMARY.TOTAL_OF",
        ONE: "TARGETACTUALSUMMARY.ONE",
        POWER: "TARGETACTUALSUMMARY.POWER",
        POWER_TIP: "TARGETACTUALSUMMARY.POWER_TIP",
        ENERGY: "TARGETACTUALSUMMARY.ENERGY",
        ENERGY_TIP: "TARGETACTUALSUMMARY.ENERGY_TIP",
        LASTUPDATE: "TARGETACTUALSUMMARY.LASTUPDATE",
        HIDE: "TARGETACTUALSUMMARY.HIDE",
        REFRESH: "TARGETACTUALSUMMARY.REFRESH",
        SHOWSUMMARY: "TARGETACTUALSUMMARY.SHOWSUMMARY",
        SINCE: "TARGETACTUALSUMMARY.SINCE",
        ATTRIBUTE: {
            TARGETACTUAL_SUMMARY: 'TARGETACTUALSUMMARY.ATTRIBUTE.TARGETACTUAL_SUMMARY',
            DISPLAYING_TEXT: 'TARGETACTUALSUMMARY.ATTRIBUTE.DISPLAYING_TEXT',
            VISABLE: 'TARGETACTUALSUMMARY.ATTRIBUTE.VISABLE',
            CURRENT_ACTUAL_DP: 'TARGETACTUALSUMMARY.ATTRIBUTE.CURRENT_ACTUAL_DP',
            CURRENT_TARGET_DP: 'TARGETACTUALSUMMARY.ATTRIBUTE.CURRENT_TARGET_DP',
            PAST_ACTUAL_DP: 'TARGETACTUALSUMMARY.ATTRIBUTE.PAST_ACTUAL_DP',
            TARGET_VALUE: 'TARGETACTUALSUMMARY.ATTRIBUTE.TARGET_VALUE',
            TARGET_UNIT: 'TARGETACTUALSUMMARY.ATTRIBUTE.TARGET_UNIT',
            OPERATION: 'TARGETACTUALSUMMARY.ATTRIBUTE.OPERATION',
            FACTOR: 'TARGETACTUALSUMMARY.ATTRIBUTE.FACTOR',
            STARTING_DATE: 'TARGETACTUALSUMMARY.ATTRIBUTE.STARTING_DATE',
        }
    },
    COMPANY: {
        SINGULAR: "COMPANY.SINGULAR",
        PLURAL: "COMPANY.PLURAL",
        ADD_NEW: "COMPANY.ADD_NEW",
        CANNOT_LOAD_LIST: "COMPANY.CANNOT_LOAD_LIST",
        BACK_TO_ALL: "COMPANY.BACK_TO_ALL",
        ATTRIBUTES: {
            COMPANY_INFO: "COMPANY.ATTRIBUTES.COMPANY_INFO",
            NAME: "COMPANY.ATTRIBUTES.NAME",
            DESCRIPTION: "COMPANY.ATTRIBUTES.DESCRIPTION",
            COMPANY_ADDRESS: "COMPANY.ATTRIBUTES.COMPANY_ADDRESS",
            LAND: "COMPANY.ATTRIBUTES.LAND",
            CITY: "COMPANY.ATTRIBUTES.CITY",
            STREET: "COMPANY.ATTRIBUTES.STREET",
            NUMBER: "COMPANY.ATTRIBUTES.NUMBER",
            POSTCODE: "COMPANY.ATTRIBUTES.POSTCODE",
            COMPANY_CONTACT: "COMPANY.ATTRIBUTES.COMPANY_CONTACT",
            TELEPHONE1: "COMPANY.ATTRIBUTES.TELEPHONE1",
            TELEPHONE2: "COMPANY.ATTRIBUTES.TELEPHONE2",
            MOBILE1: "COMPANY.ATTRIBUTES.MOBILE1",
            MOBILE2: "COMPANY.ATTRIBUTES.MOBILE2",
            EMAIL: "COMPANY.ATTRIBUTES.EMAIL"
        }
    },
    DAILYVALUES: {
        TITLE: 'DAILYVALUES.TITLE',
        DOWNLOAD_LIST: "DAILYVALUES.DOWNLOAD_LIST",
        GENERATING_PDF: "DAILYVALUES.GENERATING_PDF",
        REFRESH: "DAILYVALUES.REFRESH",
        SELECT_DATA_POINTS: "DAILYVALUES.SELECT_DATA_POINTS",
        FROM: "DAILYVALUES.FROM",
        TO: "DAILYVALUES.TO",
        RESET_DATA_POINTS: "DAILYVALUES.RESET_DATA_POINTS",
        EXPORT_AS_CSV: "DAILYVALUES.EXPORT_AS_CSV",
        SELECT_ALL: "DAILYVALUES.SELECT_ALL",
        DAILY_AUTO_GENERATION: "DAILYVALUES.DAILY_AUTO_GENERATION",
        DURATION_IN_DAYS: "DAILYVALUES.DURATION_IN_DAYS",
        REPORT_NAME: "DAILYVALUES.REPORT_NAME",
        SAVE_DAILY_REPORT: "DAILYVALUES.SAVE_DAILY_REPORT",
        LAST_DAY: "DAILYVALUES.LAST_DAY",
        LAST_DAYS_1: "DAILYVALUES.LAST_DAYS_1",
        LAST_DAYS_2: "DAILYVALUES.LAST_DAYS_2",
        REPORT_WILL_DAILY_RE_GENERATED: "DAILYVALUES.REPORT_WILL_DAILY_RE_GENERATED",
        SELECTED_DATA_POINT: "DAILYVALUES.SELECTED_DATA_POINT",
        MODIFIED_UNITS_NOTE: "DAILYVALUES.MODIFIED_UNITS_NOTE",
        NEW_REPORT_CREATED: "DAILYVALUES.NEW_REPORT_CREATED",
        PLEASE_SELECT_COMPANY: "DAILYVALUES.PLEASE_SELECT_COMPANY",
        PLEASE_SELECT_PLANT: "DAILYVALUES.PLEASE_SELECT_PLANT",
        PLEASE_SELECT_FROM_DATE: "DAILYVALUES.PLEASE_SELECT_FROM_DATE",
        PLEASE_SELECT_TO_DATE: "DAILYVALUES.PLEASE_SELECT_TO_DATE",
        PLEASE_SELECT_DATAPOINT:"DAILYVALUES.PLEASE_SELECT_DATAPOINT",
    },
    PLANT: {
        SINGULAR: "PLANT.SINGULAR",
        PLURAL: "PLANT.PLURAL",
        ADD_NEW: "PLANT.ADD_NEW",
        VISUALIZATION: "PLANT.VISUALIZATION",
        CANNOT_LOAD_LIST: "PLANT.CANNOT_LOAD_LIST",
        CONTACT_PERSON: "PLANT.CONTACT_PERSON",
        ACTIVE: "PLANT.ACTIVE",
        INACTIVE: "PLANT.INACTIVE",
        NOT_CONNECTED: "PLANT.NOT_CONNECTED",
        CONNECTED_TO: "PLANT.CONNECTED_TO",
        NO_RELATED_PLANT: "PLANT.NO_RELATED_PLANT",
        BACK_TO_ALL: "PLANT.BACK_TO_ALL",
        NO_PLANTS_TO_DISPLAY: "PLANT.NO_PLANTS_TO_DISPLAY",
        NOTHING_SELECTED: "PLANT.NOTHING_SELECTED",
        MP_LIST: "PLANT.MP_LIST",
        ATTRIBUTES: {
            CONTACT_PERSON: "PLANT.ATTRIBUTES.CONTACT_PERSON",
            EMAIL: "PLANT.ATTRIBUTES.EMAIL",
            PHONE: "PLANT.ATTRIBUTES.PHONE",
            CONNECTION: "PLANT.ATTRIBUTES.CONNECTION",
            PLANT_INFO: "PLANT.ATTRIBUTES.PLANT_INFO",
            NAME: "PLANT.ATTRIBUTES.NAME",
            DESCRIPTION: "PLANT.ATTRIBUTES.DESCRIPTION",
            COMPANY_NAME: "PLANT.ATTRIBUTES.COMPANY_NAME",
            RTIP_Plant_BGA_Name: "PLANT.ATTRIBUTES.RTIP_Plant_BGA_Name",
            ACTIVATION: "PLANT.ATTRIBUTES.ACTIVATION",
            PLANT_ADDRESS: "PLANT.ATTRIBUTES.PLANT_ADDRESS",
            LAND: "PLANT.ATTRIBUTES.LAND",
            CITY: "PLANT.ATTRIBUTES.CITY",
            STREET: "PLANT.ATTRIBUTES.STREET",
            NUMBER: "PLANT.ATTRIBUTES.NUMBER",
            POSTCODE: "PLANT.ATTRIBUTES.POSTCODE",
            PLANT_CONTACT: "PLANT.ATTRIBUTES.PLANT_CONTACT",
            STATUS: "PLANT.ATTRIBUTES.STATUS",
            LOCATION: "PLANT.ATTRIBUTES.LOCATION",
            LATITUDE: "PLANT.ATTRIBUTES.LATITUDE",
            LONGITUDE: "PLANT.ATTRIBUTES.LONGITUDE",
            SEARCH_FOR_A_CITY: "PLANT.ATTRIBUTES.SEARCH_FOR_A_CITY",
            CLICK_ON_DESIRED_CITY: "PLANT.ATTRIBUTES.CLICK_ON_DESIRED_CITY"
        },
        REPORTING: {
            TITLE: "PLANT.REPORTING.TITLE",
            DOWNLOAD_LIST: "PLANT.REPORTING.DOWNLOAD_LIST",
            THERE_ARE: 'PLANT.REPORTING.THERE_ARE',
            MP_LINKED_TO_THIS_PLANT:'PLANT.REPORTING.MP_LINKED_TO_THIS_PLANT',

        }
    },
    PLANTPART: {
        SINGULAR: "PLANTPART.SINGULAR",
        PLURAL: "PLANTPART.PLURAL",
        ADD_NEW: "PLANTPART.ADD_NEW",
        CANNOT_LOAD_LIST: "PLANTPART.CANNOT_LOAD_LIST",
        ACTIVE: "PLANTPART.ACTIVE",
        INACTIVE: "PLANTPART.INACTIVE",
        NOTHING_TO_DISPLAY: "PLANTPART.NOTHING_TO_DISPLAY",
        ESTIMATED_LIFETIME: "PLANTPART.ESTIMATED_LIFETIME",
        CURRENT_CONSUMING: "PLANTPART.CURRENT_CONSUMING",
        LAST_UPDATE: "PLANTPART.LAST_UPDATE",
        BACK_TO_ALL: "PLANTPART.BACK_TO_ALL",
        NOTHING_SELECTED: "PLANTPART.NOTHING_SELECTED",
        NO_DATA_REASON: {
            NO_INSTALLATION_DATE: 'PLANTPART.NO_DATA_REASON.NO_INSTALLATION_DATE',
            NO_PLANT: 'PLANTPART.NO_DATA_REASON.NO_PLANT',
            NO_OPERATING_HOURS:'PLANTPART.NO_DATA_REASON.NO_OPERATING_HOURS',
        },
        LIFESPAN: 'PLANTPART.LIFESPAN',
        NO_RELATED_PLANTPART: "PLANTPART.NO_RELATED_PLANTPART",
        ATTRIBUTES: {
            INSTALLATION_DATE: "PLANTPART.ATTRIBUTES.INSTALLATION_DATE",
            ORMATIC_TECH_NAME: "PLANTPART.ATTRIBUTES.ORMATIC_TECH_NAME",
            TECH_INFO: "PLANTPART.ATTRIBUTES.TECH_INFO",
            ESTIMATED_LIFETIME: "PLANTPART.ATTRIBUTES.ESTIMATED_LIFETIME",
            R_AND_I_NUMBER: "PLANTPART.ATTRIBUTES.R_AND_I_NUMBER",
            PLANT_NAME: "PLANTPART.ATTRIBUTES.PLANT_NAME",
            COMPANY_NAME: "PLANTPART.ATTRIBUTES.COMPANY_NAME",
            PLANTPART_INFO: "PLANTPART.ATTRIBUTES.PLANTPART_INFO",
            PLANTPART_DETAILS: "PLANTPART.ATTRIBUTES.PLANTPART_DETAILS",
            NAME: "PLANTPART.ATTRIBUTES.NAME",
            ACTIVATION: 'PLANTPART.ATTRIBUTES.ACTIVATION',
            TYPE: 'PLANTPART.ATTRIBUTES.TYPE'
        }
    },
    PREDEFINEDMAINTENANCEPLAN: {
        SINGULAR: "PREDEFINEDMAINTENANCEPLAN.SINGULAR",
        PLURAL: "PREDEFINEDMAINTENANCEPLAN.PLURAL",
        ADD_NEW: "PREDEFINEDMAINTENANCEPLAN.ADD_NEW",
        BACK_TO_ALL: "PREDEFINEDMAINTENANCEPLAN.BACK_TO_ALL",
        ACTIVE: "PREDEFINEDMAINTENANCEPLAN.ACTIVE",
        INACTIVE: "PREDEFINEDMAINTENANCEPLAN.INACTIVE",
        PERIODICITY: "PREDEFINEDMAINTENANCEPLAN.PERIODICITY",
        OPERATING_HOURS: "PREDEFINEDMAINTENANCEPLAN.OPERATING_HOURS",
        TEMPLATE_TASKS: "PREDEFINEDMAINTENANCEPLAN.TEMPLATE_TASKS",
        INFO: "PREDEFINEDMAINTENANCEPLAN.INFO",
        NO_TASK_TO_DISPLAY:"PREDEFINEDMAINTENANCEPLAN.NO_TASK_TO_DISPLAY",
        ATTRIBUTES: {
            ISPERIODIC: "PREDEFINEDMAINTENANCEPLAN.ATTRIBUTES.ISPERIODIC",
            YES: "PREDEFINEDMAINTENANCEPLAN.ATTRIBUTES.YES",
            NO: "PREDEFINEDMAINTENANCEPLAN.ATTRIBUTES.NO",
            PERIODINTERVAL: "PREDEFINEDMAINTENANCEPLAN.ATTRIBUTES.PERIODINTERVAL",
            PERIODTYPE: "PREDEFINEDMAINTENANCEPLAN.ATTRIBUTES.PERIODTYPE",
            ISUSINGOPERATINGHOURS: "PREDEFINEDMAINTENANCEPLAN.ATTRIBUTES.ISUSINGOPERATINGHOURS",
            OPERATINGHOURDEADLINE: "PREDEFINEDMAINTENANCEPLAN.ATTRIBUTES.OPERATINGHOURDEADLINE",
            ACTIVATION: 'PREDEFINEDMAINTENANCEPLAN.ATTRIBUTES.ACTIVATION',
            STATUS: 'PREDEFINEDMAINTENANCEPLAN.ATTRIBUTES.STATUS',
            NAME: 'PREDEFINEDMAINTENANCEPLAN.ATTRIBUTES.NAME',
        },
        TIMING: {
            DAY: "PREDEFINEDMAINTENANCEPLAN.TIMING.DAY",
            WEEK: "PREDEFINEDMAINTENANCEPLAN.TIMING.WEEK",
            MONTH: "PREDEFINEDMAINTENANCEPLAN.TIMING.MONTH",
        }
    },
    MAINTENANCEPLAN: {
        SINGULAR: "MAINTENANCEPLAN.SINGULAR",
        PLURAL:"MAINTENANCEPLAN.PLURAL",
        ACTIVE: "MAINTENANCEPLAN.ACTIVE",
        VERYCLOSE: "MAINTENANCEPLAN.VERYCLOSE",
        PASSED: "MAINTENANCEPLAN.PASSED",
        INACTIVE: "MAINTENANCEPLAN.INACTIVE",
        ADD_NEW_MAINTENANCEPLAN: "MAINTENANCEPLAN.ADD_NEW_MAINTENANCEPLAN",
        BACK_ALL_MP_ALL_DEVICE: "MAINTENANCEPLAN.BACK_ALL_MP_ALL_DEVICE",
        BACK_ALL_MP_DEVICE: "MAINTENANCEPLAN.BACK_ALL_MP_DEVICE",
        BACK_ALL_MP_PLANTPART:"MAINTENANCEPLAN.BACK_ALL_MP_PLANTPART",
        DEVICE_MAINTENANCEPLANS: "MAINTENANCEPLAN.DEVICE_MAINTENANCEPLANS",
        PLANTPART_MAINTENANCEPLANS: "MAINTENANCEPLAN.PLANTPART_MAINTENANCEPLANS",
        ALL_DEVICES_MAINTENANCEPLANS: "MAINTENANCEPLAN.ALL_DEVICES_MAINTENANCEPLANS",
        ADD_MAINTENANCEPLAN_TO_PLANTPART: "MAINTENANCEPLAN.ADD_MAINTENANCEPLAN_TO_PLANTPART",
        ADD_MAINTENANCEPLAN_TO_DEVICE: "MAINTENANCEPLAN.ADD_MAINTENANCEPLAN_TO_DEVICE",
        NOTHING_TO_DISPLAY: "MAINTENANCEPLAN.NOTHING_TO_DISPLAY",
        REPORT: "MAINTENANCEPLAN.REPORT",
        TODAY: "MAINTENANCEPLAN.TODAY",
        LINK_DP_TO_SEE_CHART: "MAINTENANCEPLAN.LINK_DP_TO_SEE_CHART",
        CLOSE_MAINTENANCEPLAN: "MAINTENANCEPLAN.CLOSE_MAINTENANCEPLAN",
        STOP_MAINTENANCEPLAN: "MAINTENANCEPLAN.STOP_MAINTENANCEPLAN",
        NOTHING_SELECTED: "MAINTENANCEPLAN.NOTHING_SELECTED",
        SELECT_PLANT_GET_MP: "MAINTENANCEPLAN.SELECT_PLANT_GET_MP",
        FILTER : {
            RUNNING: "MAINTENANCEPLAN.FILTER.RUNNING",
            INFORMATION: "MAINTENANCEPLAN.FILTER.INFORMATION",
            WARNING: "MAINTENANCEPLAN.FILTER.WARNING",
            HISTORICAL: "MAINTENANCEPLAN.FILTER.HISTORICAL",
            ACTIVE: "MAINTENANCEPLAN.FILTER.ACTIVE"
        },
        SORT: {
            BY_STATUS: "MAINTENANCEPLAN.SORT.BY_STATUS",
            BY_DATE: "MAINTENANCEPLAN.SORT.BY_DATE",
            BY_OH: "MAINTENANCEPLAN.SORT.BY_OH"
        },
        ATTRIBUTES: {
            CREATE_NEW_PERIOD:"MAINTENANCEPLAN.ATTRIBUTES.CREATE_NEW_PERIOD",
            ACCOMPLISHING_DATE: "MAINTENANCEPLAN.ATTRIBUTES.ACCOMPLISHING_DATE",
            DUE_DATE: "MAINTENANCEPLAN.ATTRIBUTES.DUE_DATE",
            REMINDING_DATE:"MAINTENANCEPLAN.ATTRIBUTES.REMINDING_DATE",
            OPERATING_HOURS: "MAINTENANCEPLAN.ATTRIBUTES.OPERATING_HOURS",
            NO_LINKED_DATA_POINT: "MAINTENANCEPLAN.ATTRIBUTES.NO_LINKED_DATA_POINT",
            CREATOR: "MAINTENANCEPLAN.ATTRIBUTES.CREATOR",
            RELATED_DEVICE: "MAINTENANCEPLAN.ATTRIBUTES.RELATED_DEVICE",
            TASKS: "MAINTENANCEPLAN.ATTRIBUTES.TASKS",
            NO_RELATED_TASKS: "MAINTENANCEPLAN.ATTRIBUTES.NO_RELATED_TASKS",
            OPERATING_HOURS_STARTING_DATE: "MAINTENANCEPLAN.ATTRIBUTES.OPERATING_HOURS_STARTING_DATE",
            REMINDING_AMOUNT: "MAINTENANCEPLAN.ATTRIBUTES.REMINDING_AMOUNT",
            STATUS: "MAINTENANCEPLAN.ATTRIBUTES.STATUS",
            TYPE: "MAINTENANCEPLAN.ATTRIBUTES.TYPE",
            EXECUTED_BY: "MAINTENANCEPLAN.ATTRIBUTES.EXECUTED_BY",
            MORE_DETAILS: "MAINTENANCEPLAN.ATTRIBUTES.MORE_DETAILS",
            PERIODICITY: "MAINTENANCEPLAN.ATTRIBUTES.PERIODICITY",
            REMINDERS_AND_NOTIFICATIONS: "MAINTENANCEPLAN.ATTRIBUTES.REMINDERS_AND_NOTIFICATIONS",
            PERIODIC: "MAINTENANCEPLAN.ATTRIBUTES.PERIODIC",
            PERIODICITY_INTERVAL: "MAINTENANCEPLAN.ATTRIBUTES.PERIODICITY_INTERVAL",
            DEADLINE_TYPE: "MAINTENANCEPLAN.ATTRIBUTES.DEADLINE_TYPE",
            MEDIA: "MAINTENANCEPLAN.ATTRIBUTES.MEDIA",
            NOTIFYING_MEDIA: "MAINTENANCEPLAN.ATTRIBUTES.NOTIFYING_MEDIA",
            REMINDING_MEDIA: "MAINTENANCEPLAN.ATTRIBUTES.REMINDING_MEDIA",
            TIME: "MAINTENANCEPLAN.ATTRIBUTES.TIME",
            REMIND_BEFORE_DAYS: "MAINTENANCEPLAN.ATTRIBUTES.REMIND_BEFORE_DAYS",
            NOTIFY_AFTER_DAYS: "MAINTENANCEPLAN.ATTRIBUTES.NOTIFY_AFTER_DAYS",
            REMIND_BEFORE_HOURS: "MAINTENANCEPLAN.ATTRIBUTES.REMIND_BEFORE_HOURS",
            NOTIFY_AFTER_HOURS: "MAINTENANCEPLAN.ATTRIBUTES.NOTIFY_AFTER_HOURS",
            CONCERNED_USRES: "MAINTENANCEPLAN.ATTRIBUTES.CONCERNED_USRES",
            USERS: "MAINTENANCEPLAN.ATTRIBUTES.USERS",
            HOURS: "MAINTENANCEPLAN.ATTRIBUTES.HOURS",
            ACTIVE: "MAINTENANCEPLAN.ATTRIBUTES.ACTIVE",
            DONE: "MAINTENANCEPLAN.ATTRIBUTES.DONE",
            FOREIGN_COMPANY: "MAINTENANCEPLAN.ATTRIBUTES.FOREIGN_COMPANY",
            MAINTENANCE_PLAN_BASICS: "MAINTENANCEPLAN.ATTRIBUTES.MAINTENANCE_PLAN_BASICS",
            MAINTENANCE_PLAN_LINKING: "MAINTENANCEPLAN.ATTRIBUTES.MAINTENANCE_PLAN_LINKING",
            RELATED_TO_PLANT_PART: "MAINTENANCEPLAN.ATTRIBUTES.RELATED_TO_PLANT_PART",
            MAINTENANCE_PLAN_DETAILS: "MAINTENANCEPLAN.ATTRIBUTES.MAINTENANCE_PLAN_DETAILS",
            NAME: "MAINTENANCEPLAN.ATTRIBUTES.NAME",
            DESCRIPTION: "MAINTENANCEPLAN.ATTRIBUTES.DESCRIPTION",
            ADD_TASK: "MAINTENANCEPLAN.ATTRIBUTES.ADD_TASK",
            LINKED_DATA_POINT: "MAINTENANCEPLAN.ATTRIBUTES.LINKED_DATA_POINT",
            DATAPOINT_UNIT: "MAINTENANCEPLAN.ATTRIBUTES.DATAPOINT_UNIT",
            CHECK_ALL: "MAINTENANCEPLAN.ATTRIBUTES.CHECK_ALL",
            WHICH_TASK_HAS_DONE: "MAINTENANCEPLAN.ATTRIBUTES.WHICH_TASK_HAS_DONE"
        },
        ADDING: {
            INITIALIZATION: "MAINTENANCEPLAN.ADDING.INITIALIZATION",
            PREDEFINED_MAINTENANCE_PLAN: "MAINTENANCEPLAN.ADDING.PREDEFINED_MAINTENANCE_PLAN",
            PLAN_DETAILS: "MAINTENANCEPLAN.ADDING.PLAN_DETAILS",
            PERIODICITY: "MAINTENANCEPLAN.ADDING.PERIODICITY",
            REMINDERS_AND_NOTIFICATIONS: "MAINTENANCEPLAN.ADDING.REMINDERS_AND_NOTIFICATIONS",
            TASKS: "MAINTENANCEPLAN.ADDING.TASKS",
            SAVE_AS_PRE_DEFINED_MAINTENANCE_PLAN:"MAINTENANCEPLAN.ADDING.SAVE_AS_PRE_DEFINED_MAINTENANCE_PLAN",
            CREATE_MAINTENANCE_PLAN: "MAINTENANCEPLAN.ADDING.CREATE_MAINTENANCE_PLAN",
            SKIP_THIS_STEP: "MAINTENANCEPLAN.ADDING.SKIP_THIS_STEP",
            PREDEFINED_MAINTENANCEPLAN: "MAINTENANCEPLAN.ADDING.PREDEFINED_MAINTENANCEPLAN",
            COPY_EXISTING_MAINTENANCEPLAN: "MAINTENANCEPLAN.ADDING.COPY_EXISTING_MAINTENANCEPLAN",
            NO_MAINTENANCEPLAN_SELECTED:"MAINTENANCEPLAN.ADDING.NO_MAINTENANCEPLAN_SELECTED"
        },
        TIMING: {
            TIME: "MAINTENANCEPLAN.TIMING.TIME",
            OH: "MAINTENANCEPLAN.TIMING.OH",
            OH_SHORT: "MAINTENANCEPLAN.TIMING.OH_SHORT",
            TIME_AND_OH_SHORT: "MAINTENANCEPLAN.TIMING.TIME_AND_OH_SHORT",
            TIME_AND_OH: "MAINTENANCEPLAN.TIMING.TIME_AND_OH",
            NOT_DETERMINED: "MAINTENANCEPLAN.TIMING.NOT_DETERMINED",
            DAY: "MAINTENANCEPLAN.TIMING.DAY",
            WEEK: "MAINTENANCEPLAN.TIMING.WEEK",
            MONTH: "MAINTENANCEPLAN.TIMING.MONTH",
            MEDIA : {
                NONE: "MAINTENANCEPLAN.TIMING.MEDIA.NONE",
                EMAIL: "MAINTENANCEPLAN.TIMING.MEDIA.EMAIL",
                SMS: "MAINTENANCEPLAN.TIMING.MEDIA.SMS",
                NOT_DETERMINED: "MAINTENANCEPLAN.TIMING.MEDIA.NOT_DETERMINED"
            }
        }
    },
    PROTOCOL : {
        SINGULAR: "PROTOCOL.SINGULAR",
        PLURAL: "PROTOCOL.PLURAL",
        NO_RELATED_PROTOCOL:"PROTOCOL.NO_RELATED_PROTOCOL",
        WHAT: "PROTOCOL.WHAT",
        WHAT_DETAILS: "PROTOCOL.WHAT_DETAILS",
        HOW: "PROTOCOL.HOW",
        HOW_DETAILS: "PROTOCOL.HOW_DETAILS",
        FAILURE_REPORT: "PROTOCOL.FAILURE_REPORT",
        COMMENTS: "PROTOCOL.COMMENTS",
        WORKING_HOURS:"PROTOCOL.WORKING_HOURS"
    },
    PRODUCT: {
        SINGULAR: "PRODUCT.SINGULAR",
        PLURAL: "PRODUCT.PLURAL",
        NO_RELATED_PRODUCT: "PRODUCT.NO_RELATED_PRODUCT",
        ADD_NEW: "PRODUCT.ADD_NEW",
        BACK_TO_ALL: "PRODUCT.BACK_TO_ALL",
        PRODUCT_INFO: "PRODUCT.PRODUCT_INFO",
        TECHNICAL_INFO: "PRODUCT.TECHNICAL_INFO",
        GENERAL_INFO: "PRODUCT.GENERAL_INFO",
        ATTRIBUTE: {
            NAME: "PRODUCT.ATTRIBUTE.NAME",
            DESCRIPTION: "PRODUCT.ATTRIBUTE.DESCRIPTION",
            MANUFACTURER: "PRODUCT.ATTRIBUTE.MANUFACTURER",
            MODEL: "PRODUCT.ATTRIBUTE.MODEL",
            MODEL_YEAR: "PRODUCT.ATTRIBUTE.MODEL_YEAR",
            MAX_OPERATING_HOURS: "PRODUCT.ATTRIBUTE.MAX_OPERATING_HOURS",
            LIFETIME_IN_MONTHS: "PRODUCT.ATTRIBUTE.LIFETIME_IN_MONTHS",
            WEB_LINK: "PRODUCT.ATTRIBUTE.WEB_LINK",
            CREATOR: "PRODUCT.ATTRIBUTE.CREATOR",
            LAST_UPDATE: "PRODUCT.ATTRIBUTE.LAST_UPDATE",
            CREATION_DATE:"PRODUCT.ATTRIBUTE.CREATION_DATE",
        }
    },
    USER: {
        SINGULAR: "USER.SINGULAR",
        PLURAL: "USER.PLURAL",
        ADD_NEW: "USER.ADD_NEW",
        NO_RELATED_USER: "USER.NO_RELATED_USER",
        BACK_TO_USER: "USER.BACK_TO_USER",
        CONSULTANTS_PLURAL: "USER.CONSULTANTS_PLURAL",
        CONSULTANTS_SINGULAR: "USER.CONSULTANTS_SINGULAR",
        ACTIVE: "USER.ACTIVE",
        INACTIVE: "USER.INACTIVE",
        LASTSEEN: "USER.LASTSEEN",
        YOU: "USER.YOU",
        SUPERADMIN: "USER.SUPERADMIN",
        SYSADMIN: "USER.SYSADMIN",
        PLANTADMIN: "USER.PLANTADMIN",
        THIS_IS_SUPERADMIN: "USER.THIS_IS_SUPERADMIN",
        THIS_IS_SYSADMIN: "USER.THIS_IS_SYSADMIN",
        THIS_IS_CONSULTANT: "USER.THIS_IS_CONSULTANT", 
        HERE: "USER.HERE",
        USER_MEMBERSHIP: "USER.USER_MEMBERSHIP",
        ADD_MEMBERSHIP: "USER.ADD_MEMBERSHIP",
        ADD_NEW_MEMBERSHIP: "USER.ADD_NEW_MEMBERSHIP",
        MEMBERSHIP_ATTRIBUTES: {
            USERGROUP: "USER.MEMBERSHIP_ATTRIBUTES.USERGROUP",
            COMPANY: "USER.MEMBERSHIP_ATTRIBUTES.COMPANY",
            PLANT: "USER.MEMBERSHIP_ATTRIBUTES.PLANT",
            NOTHING_SELECTED: "USER.MEMBERSHIP_ATTRIBUTES.NOTHING_SELECTED",
        },
        ATTRIBUTES: {
            PHONE1: "USER.ATTRIBUTES.PHONE1",
            PHONE2: "USER.ATTRIBUTES.PHONE2",
            LAST_LOGIN: "USER.ATTRIBUTES.LAST_LOGIN",
            PASSWORD: "USER.ATTRIBUTES.PASSWORD",
            ADDRESS: "USER.ATTRIBUTES.ADDRESS",
            USERNAME: "USER.ATTRIBUTES.USERNAME",
            ACTIVATION: "USER.ATTRIBUTES.ACTIVATION",
            NEW_PASSWORD: "USER.ATTRIBUTES.NEW_PASSWORD",
            RE_ENTER_NEW_PASSWORD: "USER.ATTRIBUTES.RE_ENTER_NEW_PASSWORD",
            USER_INFO: "USER.ATTRIBUTES.USER_INFO",
            INITIAL_PASSWORD:"USER.ATTRIBUTES.INITIAL_PASSWORD"
        }
    },
    DEVICE: {
        SINGULAR: "DEVICE.SINGULAR",
        PLURAL: "DEVICE.PLURAL",
        ADD_NEW: "DEVICE.ADD_NEW",
        NO_RELATED_DEVICE: "DEVICE.NO_RELATED_DEVICE",
        BACK_TO_ALL: "DEVICE.BACK_TO_ALL",
        ALL_DEVICE_IN_PLANTPART: 'DEVICE.ALL_DEVICE_IN_PLANTPART',
        ACTIVE: "DEVICE.ACTIVE",
        INACTIVE: "DEVICE.INACTIVE",
        LAST_UPDATE: "DEVICE.LAST_UPDATE",
        NOTHING_TO_DISPLAY: "DEVICE.NOTHING_TO_DISPLAY",
        SELECT_DEVICES: "DEVICE.SELECT_DEVICES",
        DOCUMENTS: "DEVICE.DOCUMENTS",
        UPLOAD_NEW_DOC: "DEVICE.UPLOAD_NEW_DOC",
        NO_DATA_REASON: {
            NO_INSTALLATION_DATE: 'DEVICE.NO_DATA_REASON.NO_INSTALLATION_DATE',
            NO_PLANT: 'DEVICE.NO_DATA_REASON.NO_PLANT',
            NO_OPERATING_HOURS: 'DEVICE.NO_DATA_REASON.NO_OPERATING_HOURS',
        },
        LIFESPAN: 'DEVICE.LIFESPAN',
        NOTHING_SELECTED: "DEVICE.NOTHING_SELECTED",
        ATTRIBUTES: {
            NAME: "DEVICE.ATTRIBUTES.NAME",
            PRODUCT: "DEVICE.ATTRIBUTES.PRODUCT",
            INSTALLATION_DATE: "DEVICE.ATTRIBUTES.INSTALLATION_DATE",
            SERIAL: "DEVICE.ATTRIBUTES.SERIAL",
            R_AND_I_NUMBER: "DEVICE.ATTRIBUTES.R_AND_I_NUMBER",
            DEVICE_INFO: "DEVICE.ATTRIBUTES.DEVICE_INFO",
            DEVICE_DETAILS: "DEVICE.ATTRIBUTES.DEVICE_DETAILS",
            ESTIMATED_LIFETIME: "DEVICE.ATTRIBUTES.ESTIMATED_LIFETIME",
            ACTIVATION: "DEVICE.ATTRIBUTES.ACTIVATION",
            STATUS: "DEVICE.ATTRIBUTES.STATUS",
            TYPE: 'DEVICE.ATTRIBUTES.TYPE'
        }
    },
    DATAPOINT: {
        SINGULAR: "DATAPOINT.SINGULAR",
        PLURAL: "DATAPOINT.PLURAL",
        ADD_NEW: "DATAPOINT.ADD_NEW",
        NO_RELATED_DATAPOINT: "DATAPOINT.NO_RELATED_DATAPOINT",
        NOTHING_TO_DISPLAY: "DATAPOINT.NOTHING_TO_DISPLAY",
        NOT_RELATED:"DATAPOINT.NOT_RELATED",
        SHOWED: "DATAPOINT.SHOWED",
        HIDDEN: "DATAPOINT.HIDDEN",
        ACTIVE: "DATAPOINT.ACTIVE",
        INACTIVE: "DATAPOINT.INACTIVE",
        BACK_TO_ALL: "DATAPOINT.BACK_TO_ALL",
        ADD_NEW_TO_PLANTPART: "DATAPOINT.ADD_NEW_TO_PLANTPART",
        ADD_NEW_TO_DEVICE: "DATAPOINT.ADD_NEW_TO_DEVICE",
        DATAPOINTS_OF_DEVICE: "DATAPOINT.DATAPOINTS_OF_DEVICE",
        DATAPOINTS_OF_PLANTPART: "DATAPOINT.DATAPOINTS_OF_PLANTPART",
        CLICK_TO_REFRESH: 'DATAPOINT.CLICK_TO_REFRESH',
        TYPE: {
            BETRIEBSSTUNDEN: 'DATAPOINT.TYPE.BETRIEBSSTUNDEN',
            PROZESSWERT: 'DATAPOINT.TYPE.PROZESSWERT',
            TAGESWERT: 'DATAPOINT.TYPE.TAGESWERT',
        },
        BETRIEBSSTUNDEN_FUNCTION: {
            ON_TIME_YRSTERDAY: "DATAPOINT.BETRIEBSSTUNDEN_FUNCTION.ON_TIME_YRSTERDAY",
            ON_TIME_ABSOLUTE: "DATAPOINT.BETRIEBSSTUNDEN_FUNCTION.ON_TIME_ABSOLUTE",
            OFF_TIME_YRSTERDAY: "DATAPOINT.BETRIEBSSTUNDEN_FUNCTION.OFF_TIME_YRSTERDAY",
            OFF_TIME_ABSOLUTE: "DATAPOINT.BETRIEBSSTUNDEN_FUNCTION.OFF_TIME_ABSOLUTE",
            DISRUPTION_TIME_YRSTERDAY: "DATAPOINT.BETRIEBSSTUNDEN_FUNCTION.DISRUPTION_TIME_YRSTERDAY",
            DISRUPTION_TIME_ABSOLUTE: "DATAPOINT.BETRIEBSSTUNDEN_FUNCTION.DISRUPTION_TIME_ABSOLUTE",
        },
        ATTRIBUTES: {
            DATAPOINT_INFO: "DATAPOINT.ATTRIBUTES.DATAPOINT_INFO",
            NAME: "DATAPOINT.ATTRIBUTES.NAME",
            SHORTNAME: "DATAPOINT.ATTRIBUTES.SHORTNAME",
            PLANT_PART: "DATAPOINT.ATTRIBUTES.PLANT_PART",
            DEVICE: "DATAPOINT.ATTRIBUTES.DEVICE",
            DATAPOINT_DETAILS: "DATAPOINT.ATTRIBUTES.DATAPOINT_DETAILS",
            ACTIVATION: "DATAPOINT.ATTRIBUTES.ACTIVATION",
            TYPE: "DATAPOINT.ATTRIBUTES.TYPE",
            RTIP_NUMBER: "DATAPOINT.ATTRIBUTES.RTIP_NUMBER",
            NOTES: "DATAPOINT.ATTRIBUTES.NOTES",
            FUNCTION: "DATAPOINT.ATTRIBUTES.FUNCTION",
            DISPLAY: "DATAPOINT.ATTRIBUTES.DISPLAY",
            EXISTING_DATA_POINTS: "DATAPOINT.ATTRIBUTES.EXISTING_DATA_POINTS",
            NOTHING_SELECTED: "DATAPOINT.ATTRIBUTES.NOTHING_SELECTED",
            STATUS: "DATAPOINT.ATTRIBUTES.STATUS",
            FACTOR: "DATAPOINT.ATTRIBUTES.FACTOR",
            MODIFIED_UNIT: "DATAPOINT.ATTRIBUTES.MODIFIED_UNIT",
            MODIFIED_UNIT_NOTE: "DATAPOINT.ATTRIBUTES.MODIFIED_UNIT_NOTE",
            TRANSFORMATION:"DATAPOINT.ATTRIBUTES.TRANSFORMATION"
        }
    },
    USERGROUP: {
        SINGULAR: "USERGROUP.SINGULAR",
        PLURAL: "USERGROUP.PLURAL",
        ADD_NEW: "USERGROUP.ADD_NEW",
        CANNOT_LOAD_LIST: "USERGROUP.CANNOT_LOAD_LIST",
        NAME: "USERGROUP.NAME",
        DESCRIPTION: "USERGROUP.DESCRIPTION",
        BACK_TO_ALL: "USERGROUP.BACK_TO_ALL",
        MODIFY_USERGROUP_RIGHTS: "USERGROUP.MODIFY_USERGROUP_RIGHTS",
        MODIFY_USERGROUP_ROLES: "USERGROUP.MODIFY_USERGROUP_ROLES",
    },
    ROLE: {
        SINGULAR: "ROLE.SINGULAR",
        PLURAL: "ROLE.PLURAL",
        ADD_NEW: "ROLE.ADD_NEW",
        CANNOT_LOAD_LIST: "ROLE.CANNOT_LOAD_LIST",
        NAME: "ROLE.NAME",
        DESCRIPTION: "ROLE.DESCRIPTION",
        NO_RELATED_ROLE: "ROLE.NO_RELATED_ROLE",
    },
    RIGHT: {
        SINGULAR: "RIGHT.SINGULAR",
        PLURAL: "RIGHT.PLURAL",
        ADD_NEW: "RIGHT.ADD_NEW",
        CANNOT_LOAD_LIST: "RIGHT.CANNOT_LOAD_LIST",
        NAME: "RIGHT.NAME",
        DESCRIPTION: "RIGHT.DESCRIPTION",
        NO_RELATED_RIGHT: "RIGHT.NO_RELATED_RIGHT",
    },
    FILESERVER: {
        DOCUMENTS: "FILESERVER.DOCUMENTS",
        SINGULAR: "FILESERVER.SINGULAR",
        PLURAL: "FILESERVER.PLURAL",
        TITLE: "FILESERVER.TITLE",
        NAME: 'FILESERVER.NAME',
        DESCRIPTION: 'FILESERVER.DESCRIPTION',
        FILETYPE: 'FILESERVER.FILETYPE',
        CREATION_DATE: 'FILESERVER.CREATION_DATE',
        EXPIRATION_DATE: 'FILESERVER.EXPIRATION_DATE',
        FILE_SIZE: 'FILESERVER.FILE_SIZE',
        NOTE: 'FILESERVER.NOTE',
        ISCOPIED: 'FILESERVER.ISCOPIED',
        SOURCE: 'FILESERVER.SOURCE',
        PICK_FILE: 'FILESERVER.PICK_FILE',
        NO_RELATED_DOCUMENTS: "FILESERVER.NO_RELATED_DOCUMENTS",
        DESCRIPTIONS: {
            DOCUMENT: "FILESERVER.DESCRIPTIONS.DOCUMENT",
            DATA_SHEET: "FILESERVER.DESCRIPTIONS.DATA_SHEET",
            MAINTENANCE_DOC: "FILESERVER.DESCRIPTIONS.MAINTENANCE_DOC",
            EMERGENCY_PLAN: "FILESERVER.DESCRIPTIONS.EMERGENCY_PLAN",
            SECURITY_CHECK: "FILESERVER.DESCRIPTIONS.SECURITY_CHECK",
            LABORATORY_RESULT: "FILESERVER.DESCRIPTIONS.LABORATORY_RESULT",
            CERTIFICATE: "FILESERVER.DESCRIPTIONS.CERTIFICATE",
            IMAGE: "FILESERVER.DESCRIPTIONS.IMAGE",
            EXPERT_REPORT: "FILESERVER.DESCRIPTIONS.EXPERT_REPORT"
        }
    },
    TRENDS: {
        TITLE: "TRENDS.TITLE",
        REFRESH: "TRENDS.REFRESH",
        SELECT_DATA_POINTS: "TRENDS.SELECT_DATA_POINTS",
        FROM: "TRENDS.FROM",
        TO: "TRENDS.TO",
        RESET_DATA_POINTS: "TRENDS.RESET_DATA_POINTS",
        EXPORT_AS_CSV: "TRENDS.EXPORT_AS_CSV",
        SELECT_ALL: "TRENDS.SELECT_ALL",
        DAILY_AUTO_GENERATION: "TRENDS.DAILY_AUTO_GENERATION",
        DURATION_IN_DAYS: "TRENDS.DURATION_IN_DAYS",
        REPORT_NAME: "TRENDS.REPORT_NAME",
        SAVE_TRENDS_REPORT: "TRENDS.SAVE_TRENDS_REPORT",
        LAST_DAY: "TRENDS.LAST_DAY",
        LAST_DAYS_1: "TRENDS.LAST_DAYS_1",
        LAST_DAYS_2: "TRENDS.LAST_DAYS_2",
        REPORT_WILL_DAILY_RE_GENERATED: "TRENDS.REPORT_WILL_DAILY_RE_GENERATED",
        SELECTED_DATA_POINT: "TRENDS.SELECTED_DATA_POINT",
        MODIFIED_UNITS_NOTE: "TRENDS.MODIFIED_UNITS_NOTE",
        DATE: "TRENDS.DATE",
        MORE_POINTS: "TRENDS.MORE_POINTS",
        LESS_POINTS: "TRENDS.LESS_POINTS",
        NEW_REPORT_CREATED: "TRENDS.NEW_REPORT_CREATED",
        PLEASE_SELECT_COMPANY: "TRENDS.PLEASE_SELECT_COMPANY",
        PLEASE_SELECT_PLANT: "TRENDS.PLEASE_SELECT_PLANT",
        PLEASE_SELECT_FROM_DATE: "TRENDS.PLEASE_SELECT_FROM_DATE",
        PLEASE_SELECT_TO_DATE: "TRENDS.PLEASE_SELECT_TO_DATE",
        PLEASE_SELECT_DATAPOINT: "TRENDS.PLEASE_SELECT_DATAPOINT",
    },
    REPORT_MANAGER: {
        TITLE: 'REPORT_MANAGER.TITLE',
        ADD_NEW: "REPORT_MANAGER.ADD_NEW",
        BACK_TO_ALL: "REPORT_MANAGER.BACK_TO_ALL",
        SINGULAR: "REPORT_MANAGER.SINGULAR",
        RECENT_PERIOD: "REPORT_MANAGER.RECENT_PERIOD",
        SPECIFIC_PERIOD: "REPORT_MANAGER.SPECIFIC_PERIOD",
        TIMING: {
            DAY: "REPORT_MANAGER.TIMING.DAY",
            WEEK: "REPORT_MANAGER.TIMING.WEEK",
            MONTH: "REPORT_MANAGER.TIMING.MONTH"
        },
        STATUS: {
            ACTIVE: "REPORT_MANAGER.STATUS.ACTIVE",
            INACTIVE: "REPORT_MANAGER.STATUS.INACTIVE",
            SUSPENDED: "REPORT_MANAGER.STATUS.SUSPENDED"
        },
        TYPE: {
            D: "REPORT_MANAGER.TYPE.D",
            T: "REPORT_MANAGER.TYPE.T",
            A: "REPORT_MANAGER.TYPE.A",
            G: "REPORT_MANAGER.TYPE.G"
        },
        ATTRIBUTES: {
            DOCUMENT_SERVER:"REPORT_MANAGER.ATTRIBUTES.DOCUMENT_SERVER",
            DURATION: "REPORT_MANAGER.ATTRIBUTES.DURATION",
            FROM_DATE: "REPORT_MANAGER.ATTRIBUTES.FROM_DATE",
            FROM_TO: "REPORT_MANAGER.ATTRIBUTES.FROM_TO",
            TITLE: 'REPORT_MANAGER.ATTRIBUTES.TITLE',
            FILE_NAME: 'REPORT_MANAGER.ATTRIBUTES.FILE_NAME',
            STATUS: 'REPORT_MANAGER.ATTRIBUTES.STATUS',
            TYPE: 'REPORT_MANAGER.ATTRIBUTES.TYPE',
            PERIOD_AMOUNT: 'REPORT_MANAGER.ATTRIBUTES.PERIOD_AMOUNT',
            PERIOD_UNIT: 'REPORT_MANAGER.ATTRIBUTES.PERIOD_UNIT',
            IS_RECENT_PERIOD: 'REPORT_MANAGER.ATTRIBUTES.IS_RECENT_PERIOD',
            STARTING_DATE: 'REPORT_MANAGER.ATTRIBUTES.STARTING_DATE',
            IS_UNTIL_NOW: 'REPORT_MANAGER.ATTRIBUTES.IS_UNTIL_NOW',
            ENDING_DATE: 'REPORT_MANAGER.ATTRIBUTES.ENDING_DATE',
            IS_AUTO_GENERATING: 'REPORT_MANAGER.ATTRIBUTES.IS_AUTO_GENERATING',
            REPORTED_PERIOD: 'REPORT_MANAGER.ATTRIBUTES.REPORTED_PERIOD',
            GENERAL: 'REPORT_MANAGER.ATTRIBUTES.GENERAL',
            REPORTED_DURATION: 'REPORT_MANAGER.ATTRIBUTES.REPORTED_DURATION',
            AUTO_GENERATING: 'REPORT_MANAGER.ATTRIBUTES.AUTO_GENERATING',
            EXPORTING_MEDIA: 'REPORT_MANAGER.ATTRIBUTES.EXPORTING_MEDIA',
            DATA_POINTS:'REPORT_MANAGER.ATTRIBUTES.DATA_POINTS',
        }
    },
    ADMINISTRATION: {
        TITLE: "ADMINISTRATION.TITLE",
        RTIP_ADDNEW_PLANT: "ADMINISTRATION.RTIP_ADDNEW_PLANT",
        RTIP_ADDNEW_PW: "ADMINISTRATION.RTIP_ADDNEW_PW",
        RTIP_ADDNEW_PTW: "ADMINISTRATION.RTIP_ADDNEW_PTW",
        RTIP_ADDNEW_BS: "ADMINISTRATION.RTIP_ADDNEW_BS",
        BACK_TO_MAIN_ADMIN_PAGE: "ADMINISTRATION.BACK_TO_MAIN_ADMIN_PAGE",
    },
    HOWTO: {
        TITLE: "HOWTO.TITLE",
        BACK_TO_ALL: "HOWTO.BACK_TO_ALL",
        ADD_NEW: "HOWTO.ADD_NEW",
        SINGULAR: "HOWTO.SINGULAR",
        PLURAL: "HOWTO.PLURAL",
        NO_ARTICLES: "HOWTO.NO_ARTICLES",
        ATTRIBUTE: {
            TITLE: "HOWTO.ATTRIBUTE.TITLE",
            LANGUAGE: "HOWTO.ATTRIBUTE.LANGUAGE",
            PUBLISHED: "HOWTO.ATTRIBUTE.PUBLISHED",
            TAGS: "HOWTO.ATTRIBUTE.TAGS",
            NEW_TAG: "HOWTO.ATTRIBUTE.NEW_TAG",
            SUGGESTIONS: "HOWTO.ATTRIBUTE.SUGGESTIONS"
        },
        ENGLISH: "HOWTO.ENGLISH",
        GERMAN: "HOWTO.GERMAN",
        PREVIEW: "HOWTO.PREVIEW",
    },
    PORTALEMAIL: {
        TITLE: "PORTALEMAIL.TITLE",
        EMAILTITLE: "PORTALEMAIL.EMAILTITLE",
        EMAILBODY:"PORTALEMAIL.EMAILBODY",
        TO: 'PORTALEMAIL.TO',
        CC: 'PORTALEMAIL.CC',
    },
    RTIPADMIN: {
        PLANT: {
            MAIN_LINK: "RTIPADMIN.PLANT.MAIN_LINK",
            NEW_BGA_PLANT: "RTIPADMIN.PLANT.NEW_BGA_PLANT",
            BGA_NAME: "RTIPADMIN.PLANT.BGA_NAME",
        },
        PW: {
            MAIN_LINK: "RTIPADMIN.PW.MAIN_LINK",
            STEP_INIT: {
                DETERMINE: "RTIPADMIN.PW.STEP_INIT.DETERMINE",
                BGA_NAME: "RTIPADMIN.PW.STEP_INIT.BGA_NAME",
                TITLE: "RTIPADMIN.PW.STEP_INIT.TITLE",
            },
            STEP1: {
                TITLE: "RTIPADMIN.PW.STEP1.TITLE",
                TEXT_1: "RTIPADMIN.PW.STEP1.TEXT_1",
                TEXT_2: "RTIPADMIN.PW.STEP1.TEXT_2",
                TEXT_3_LINK: "RTIPADMIN.PW.STEP1.TEXT_3_LINK",
                TEXT_4: "RTIPADMIN.PW.STEP1.TEXT_4",
            },
            STEP2: {
                TITLE: "RTIPADMIN.PW.STEP2.TITLE",
                TEXT_ALL_RECORD_TITLE: "RTIPADMIN.PW.STEP2.TEXT_ALL_RECORD_TITLE",
                TEXT_ALL_RECORD_TEXT1: "RTIPADMIN.PW.STEP2.TEXT_ALL_RECORD_TEXT1",
                TEXT_ALL_RECORD_TEXT2: "RTIPADMIN.PW.STEP2.TEXT_ALL_RECORD_TEXT2",
                TEXT_ALL_RECORD_TEXT3_LINK: "RTIPADMIN.PW.STEP2.TEXT_ALL_RECORD_TEXT3_LINK",
                TEXT_ALL_RECORD_TEXT4: "RTIPADMIN.PW.STEP2.TEXT_ALL_RECORD_TEXT4",
                TEXT_SELECT_PWS_TITLE: "RTIPADMIN.PW.STEP2.TEXT_SELECT_PWS_TITLE",
                TEXT_SELECT_PWS_TEXT1: "RTIPADMIN.PW.STEP2.TEXT_SELECT_PWS_TEXT1",
                TEXT_SELECT_PWS_TEXT2: "RTIPADMIN.PW.STEP2.TEXT_SELECT_PWS_TEXT2",
                TEXT_SELECT_PWS_TEXT3: "RTIPADMIN.PW.STEP2.TEXT_SELECT_PWS_TEXT3",
                TEXT_SELECT_PWS_BUTTON: "RTIPADMIN.PW.STEP2.TEXT_SELECT_PWS_BUTTON",
                LOAD_PWS: "RTIPADMIN.PW.STEP2.LOAD_PWS",
                NEW_PW_ON_LOCAL: "RTIPADMIN.PW.STEP2.NEW_PW_ON_LOCAL",
            },
            STEP3: {
                TITLE: "RTIPADMIN.PW.STEP3.TITLE",
                TAB_COPY_TITLE: "RTIPADMIN.PW.STEP3.TAB_COPY_TITLE",
                TAB_COPY_TEXT1: "RTIPADMIN.PW.STEP3.TAB_COPY_TEXT1",
                TAB_COPY_BUTTON1: "RTIPADMIN.PW.STEP3.TAB_COPY_BUTTON1",
                TAB_COPY_BUTTON2: "RTIPADMIN.PW.STEP3.TAB_COPY_BUTTON2",
                TAB_COPY_BUTTON3: "RTIPADMIN.PW.STEP3.TAB_COPY_BUTTON3",
                TAB_SELECT_TITLE: "RTIPADMIN.PW.STEP3.TAB_SELECT_TITLE",
                TAB_SELECT_TEXT1: "RTIPADMIN.PW.STEP3.TAB_SELECT_TEXT1",
                TAB_SELECT_TEXT2: "RTIPADMIN.PW.STEP3.TAB_SELECT_TEXT2",
                TAB_SELECT_BUTTON: "RTIPADMIN.PW.STEP3.TAB_SELECT_BUTTON",
                BUTTON: "RTIPADMIN.PW.STEP3.BUTTON",
            },
            STEP4: {
                TITLE: "RTIPADMIN.PW.STEP4.TITLE",
                TEXT1: "RTIPADMIN.PW.STEP4.TEXT1",
                ADD_NEW_UNIT: "RTIPADMIN.PW.STEP4.ADD_NEW_UNIT",
                NOT_SELECTED: "RTIPADMIN.PW.STEP4.NOT_SELECTED",
            },
            STEP5: {
                TITLE: "RTIPADMIN.PW.STEP5.TITLE",
                TEXT1: "RTIPADMIN.PW.STEP5.TEXT1",
                BUTTON:"RTIPADMIN.PW.STEP5.BUTTON",
            },
            STEP6: {
                TITLE: "RTIPADMIN.PW.STEP6.TITLE",
                TEXT1:"RTIPADMIN.PW.STEP6.TEXT1",
            }
        },
        PTW: {
            MAIN_LINK: "RTIPADMIN.PTW.MAIN_LINK",
            STEP_INIT: {
                DETERMINE: "RTIPADMIN.PTW.STEP_INIT.DETERMINE",
                BGA_NAME: "RTIPADMIN.PTW.STEP_INIT.BGA_NAME",
                TITLE: "RTIPADMIN.PTW.STEP_INIT.TITLE",
            },
            STEP1: {
                TITLE: "RTIPADMIN.PTW.STEP1.TITLE",
                TEXT1: "RTIPADMIN.PTW.STEP1.TEXT1",
            },
            STEP2: {
                TITLE: "RTIPADMIN.PTW.STEP2.TITLE",
                TEXT_ALL_RECORD_TITLE: "RTIPADMIN.PTW.STEP2.TEXT_ALL_RECORD_TITLE",
                TEXT_ALL_RECORD_TEXT1: "RTIPADMIN.PTW.STEP2.TEXT_ALL_RECORD_TEXT1",
                TEXT_ALL_RECORD_TEXT2: "RTIPADMIN.PTW.STEP2.TEXT_ALL_RECORD_TEXT2",
                TEXT_ALL_RECORD_TEXT3_LINK: "RTIPADMIN.PTW.STEP2.TEXT_ALL_RECORD_TEXT3_LINK",
                TEXT_ALL_RECORD_TEXT4: "RTIPADMIN.PTW.STEP2.TEXT_ALL_RECORD_TEXT4",
                TEXT_SELECT_PWS_TITLE: "RTIPADMIN.PTW.STEP2.TEXT_SELECT_PWS_TITLE",
                TEXT_SELECT_PWS_TEXT1: "RTIPADMIN.PTW.STEP2.TEXT_SELECT_PWS_TEXT1",
                TEXT_SELECT_PWS_TEXT2: "RTIPADMIN.PTW.STEP2.TEXT_SELECT_PWS_TEXT2",
                TEXT_SELECT_PWS_TEXT3: "RTIPADMIN.PTW.STEP2.TEXT_SELECT_PWS_TEXT3",
                TEXT_SELECT_PWS_BUTTON: "RTIPADMIN.PTW.STEP2.TEXT_SELECT_PWS_BUTTON",
                LOAD_PWS: "RTIPADMIN.PTW.STEP2.LOAD_PWS",
                NEW_PW_ON_LOCAL: "RTIPADMIN.PTW.STEP2.NEW_PW_ON_LOCAL",
            },
            STEP3: {
                TITLE: "RTIPADMIN.PTW.STEP3.TITLE",
                TAB_COPY_TITLE: "RTIPADMIN.PTW.STEP3.TAB_COPY_TITLE",
                TAB_COPY_TEXT1: "RTIPADMIN.PTW.STEP3.TAB_COPY_TEXT1",
                TAB_COPY_BUTTON1: "RTIPADMIN.PTW.STEP3.TAB_COPY_BUTTON1",
                TAB_COPY_BUTTON2: "RTIPADMIN.PTW.STEP3.TAB_COPY_BUTTON2",
                TAB_COPY_BUTTON3: "RTIPADMIN.PTW.STEP3.TAB_COPY_BUTTON3",
                TAB_SELECT_TITLE: "RTIPADMIN.PTW.STEP3.TAB_SELECT_TITLE",
                TAB_SELECT_TEXT1: "RTIPADMIN.PTW.STEP3.TAB_SELECT_TEXT1",
                TAB_SELECT_TEXT2: "RTIPADMIN.PTW.STEP3.TAB_SELECT_TEXT2",
                TAB_SELECT_BUTTON: "RTIPADMIN.PTW.STEP3.TAB_SELECT_BUTTON",
                BUTTON: "RTIPADMIN.PTW.STEP3.BUTTON",
            },
            STEP4: {
                TITLE: "RTIPADMIN.PTW.STEP4.TITLE",
                TEXT1: "RTIPADMIN.PTW.STEP4.TEXT1",
                ADD_NEW_UNIT: "RTIPADMIN.PTW.STEP4.ADD_NEW_UNIT",
                NOT_SELECTED: "RTIPADMIN.PTW.STEP4.NOT_SELECTED",
            },
            STEP5: {
                TITLE: "RTIPADMIN.PTW.STEP5.TITLE",
                TEXT1: "RTIPADMIN.PTW.STEP5.TEXT1",
                BUTTON: "RTIPADMIN.PTW.STEP5.BUTTON",
            },
        },
        BS: {
            MAIN_LINK: "RTIPADMIN.BS.MAIN_LINK",
            STEP_INIT: {
                DETERMINE: "RTIPADMIN.BS.STEP_INIT.DETERMINE",
                BGA_NAME: "RTIPADMIN.BS.STEP_INIT.BGA_NAME",
                TITLE: "RTIPADMIN.BS.STEP_INIT.TITLE",
            },
            STEP1: {
                TITLE: "RTIPADMIN.BS.STEP1.TITLE",
                TEXT1: "RTIPADMIN.BS.STEP1.TEXT1",
            },
            STEP2: {
                TITLE: "RTIPADMIN.BS.STEP2.TITLE",
                TEXT_ALL_RECORD_TITLE: "RTIPADMIN.BS.STEP2.TEXT_ALL_RECORD_TITLE",
                TEXT_ALL_RECORD_TEXT1: "RTIPADMIN.BS.STEP2.TEXT_ALL_RECORD_TEXT1",
                TEXT_ALL_RECORD_TEXT2: "RTIPADMIN.BS.STEP2.TEXT_ALL_RECORD_TEXT2",
                TEXT_ALL_RECORD_TEXT3_LINK: "RTIPADMIN.BS.STEP2.TEXT_ALL_RECORD_TEXT3_LINK",
                TEXT_ALL_RECORD_TEXT4: "RTIPADMIN.BS.STEP2.TEXT_ALL_RECORD_TEXT4",
                TEXT_SELECT_PWS_TITLE: "RTIPADMIN.BS.STEP2.TEXT_SELECT_PWS_TITLE",
                TEXT_SELECT_PWS_TEXT1: "RTIPADMIN.BS.STEP2.TEXT_SELECT_PWS_TEXT1",
                TEXT_SELECT_PWS_TEXT2: "RTIPADMIN.BS.STEP2.TEXT_SELECT_PWS_TEXT2",
                TEXT_SELECT_PWS_TEXT3: "RTIPADMIN.BS.STEP2.TEXT_SELECT_PWS_TEXT3",
                TEXT_SELECT_PWS_BUTTON: "RTIPADMIN.BS.STEP2.TEXT_SELECT_PWS_BUTTON",
                LOAD_PWS: "RTIPADMIN.BS.STEP2.LOAD_PWS",
                NEW_PW_ON_LOCAL: "RTIPADMIN.BS.STEP2.NEW_PW_ON_LOCAL",
            },
            STEP3: {
                TITLE: "RTIPADMIN.BS.STEP3.TITLE",
                TAB_COPY_TITLE: "RTIPADMIN.BS.STEP3.TAB_COPY_TITLE",
                TAB_COPY_TEXT1: "RTIPADMIN.BS.STEP3.TAB_COPY_TEXT1",
                TAB_COPY_BUTTON1: "RTIPADMIN.BS.STEP3.TAB_COPY_BUTTON1",
                TAB_COPY_BUTTON2: "RTIPADMIN.BS.STEP3.TAB_COPY_BUTTON2",
                TAB_COPY_BUTTON3: "RTIPADMIN.BS.STEP3.TAB_COPY_BUTTON3",
                TAB_SELECT_TITLE: "RTIPADMIN.BS.STEP3.TAB_SELECT_TITLE",
                TAB_SELECT_TEXT1: "RTIPADMIN.BS.STEP3.TAB_SELECT_TEXT1",
                TAB_SELECT_TEXT2: "RTIPADMIN.BS.STEP3.TAB_SELECT_TEXT2",
                TAB_SELECT_BUTTON: "RTIPADMIN.BS.STEP3.TAB_SELECT_BUTTON",
                BUTTON: "RTIPADMIN.BS.STEP3.BUTTON",
            },
            STEP4: {
                TITLE: "RTIPADMIN.BS.STEP4.TITLE",
                TEXT1: "RTIPADMIN.BS.STEP4.TEXT1",
                ADD_NEW_DESCRIPTION: "RTIPADMIN.BS.STEP4.ADD_NEW_DESCRIPTION",
                NOT_SELECTED: "RTIPADMIN.BS.STEP4.NOT_SELECTED",
            },
            STEP5: {
                TITLE: "RTIPADMIN.BS.STEP5.TITLE",
                TEXT1: "RTIPADMIN.BS.STEP5.TEXT1",
                BUTTON: "RTIPADMIN.BS.STEP5.BUTTON",
            },
        },
    }
} 


